import { Component, ElementRef, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormControl, Validators } from "@angular/forms";
import { PersonSearchService } from "../../../_services/person-search.service";
import { ENTER, COMMA } from "@angular/cdk/keycodes";
import * as _ from 'underscore';
import { LoadingService } from "src/app/_services/loading.service";
import { DataService } from 'src/app/data.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Subject, Subscription, SubscriptionLike } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { MatAutocompleteTrigger as MatAutocompleteTrigger } from '@angular/material/autocomplete';
type ValueConverter = any;
import { GlobalService } from 'src/app/_services/global.service';
import { SuggestedTitle } from "src/app/openai/suggested-titles/suggested-titles.component";
import { CallStage } from 'src/app/enums/CallStage';
import { CompanyInsightsService } from 'src/app/_services/company-insights.service';
import { ContinentHandlerService } from 'src/app/_services/continent-handler.service';
import cjson from 'compressed-json';
import { Location } from '@angular/common';
import moment from 'moment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EuropeAccessModalComponent } from 'src/app/europe-access-modal/europe-access-modal.component';
declare const clevertap;


@Component({
    selector: "app-advance-search",
    templateUrl: "./advance-search.component.html",
    styleUrls: ["./advance-search.component.scss"],
    standalone: false
})
export class AdvanceSearchComponent implements OnInit, OnDestroy {
  private typeAheadSubject = new Subject<{ event: Event, type: string }>();
  @ViewChild(MatAutocompleteTrigger) autocomplete: MatAutocompleteTrigger;

  addOnBlur: boolean = true
  searchKeyword: string;
  totalCandidatesCount: number = 0;
  editQuery: boolean = false;
  success_message: string;
  selectable = true;
  removable = true;
  gender: any = "All";
  candidateshavingmobilenumber: boolean = false
  candidateshavingpersonalemail: boolean = false
  candidateshavingprofessionalemail: boolean = false
  candidateshavingsocialprofiles: boolean = false
  seniority: any = [];

  /**
   * Job Title Status Filter for radio button
   */
  jobtitletype: string = 'Current';

  /**
   * Job Title Input for autocomplete
   */
  jobTitleInput: UntypedFormControl = new UntypedFormControl(null);

  /**
   * Job Title List for autocomplete
   */
  jobTitleList: any = [];

  /**
   * Job Title Selected List for autocomplete
   */
  jobTitleSelectedList: any = [];
  jobTitleTopList: any = [];
  locationInput: UntypedFormControl = new UntypedFormControl(null);
  locationList: any = [];
  locationSelectedList: any = [];
  locationTopList: any = [];


  // current work city
  currentWorkCityInput: UntypedFormControl = new UntypedFormControl(null);
  currentWorkCityList: any = [];
  currentWorkCitySelectedList: any = [];

  // current work country
  currentWorkCountryInput: UntypedFormControl = new UntypedFormControl(null);
  currentWorkCountryList: any = [];
  currentWorkCountrySelectedList: any = [];

  // current work locality
  currentWorkLocalityInput: UntypedFormControl = new UntypedFormControl(null);
  currentWorkLocalityList: any = [];
  currentWorkLocalitySelectedList: any = [];

  // skills
  skillsInput: UntypedFormControl = new UntypedFormControl(null);
  skillsList: any = [];
  skillsSelectedList: any = [];
  skillsTopList: any = [];

  // company
  companyInput: UntypedFormControl = new UntypedFormControl(null);
  companyList: any = [];
  companySelectedList: any = [];

  // industry
  industryInput: UntypedFormControl = new UntypedFormControl(null);
  industryList: any = [];
  industrySelectedList: any = [];
  industryTopList: any = [];
  industrytype: string = 'Current';

  // field of study
  fieldOfStudyInput: UntypedFormControl = new UntypedFormControl(null);
  fieldOfStudyList: any = [];
  fieldOfStudySelectedList: any = [];
  fieldOfStudyTopList: any = [];

  // Seniority Level
  seniorityLevelInput: UntypedFormControl = new UntypedFormControl(null);
  seniorityLevelList: any = [];
  seniorityLevelSelectedList: any = [];
  seniorityInput: any = null

  // education
  educationInput: UntypedFormControl = new UntypedFormControl(null);
  educationList: any = [];
  educationSelectedList: any = [];
  educationTopList: any = [];

  // zip code
  zipCodeInput: UntypedFormControl = new UntypedFormControl(null);
  zipCodeList: any = [];
  zipCodeSelectedList: any = [];

  // school
  schoolInput: UntypedFormControl = new UntypedFormControl(null);
  schoolList: any = [];
  schoolSelectedList: any = [];
  schoolTopList: any = [];

  // company size
  companySizeInput: UntypedFormControl = new UntypedFormControl(null);
  companySizeList: any = [];
  companySizeSelectedList: any = [];
  companysize: any = [];
  companyTopList: any = [];
  companytype: string = 'Current or Past';

  companySizeOption: any = ["1-10", "11-50", "51-200", "201-500", "501-1000", "1001-5000", "5001-10000", "10001+"]
  graduationYearInput: UntypedFormControl = new UntypedFormControl(null);
  graduationYearSelectedList: any = [];
  separatorKeysCodes: number[] = [ENTER, COMMA];
  separatorKeysCodesForLocation: number[] = [ENTER];
  pageNumber: number = 1;
  pageSize: number = 10;
  currentPage: number = 1;
  start: any //- start number for pagination (from)
  end: any //- end number for paginatuin (to)
  isInsightsActive: boolean = true;
  isListingActive: boolean = false;
  candidateList: any = [];
  requestObject: any;
  reportsAggs: any;
  dataSourceCurrentCompany: any = [];
  dataSourceFunctions: any = [];
  dataSourceWorkCountry: any = [];
  dataSourcePastCompany: any = [];
  dataSourceSkills: any = [];
  dataSourceCurrentJobTitle: any = [];
  dataSourcePastJobTitle: any = [];
  dataSourceGender: any = [];
  dataSourceSeniority: any = [];
  aggregations: any = [];
  dataSourceYearsOfExperience: any = [];
  languageInput: UntypedFormControl = new UntypedFormControl(null);
  languageList: any = [];
  languageSelectedList: any = [];
  languageTopList: any = [];
  yearsofexperience: any = 'Past';
  yearsofexperienceFrom: UntypedFormControl = new UntypedFormControl(null);
  yearsofexperienceTo: UntypedFormControl = new UntypedFormControl(null);
  currentyearsofexperienceFrom: UntypedFormControl = new UntypedFormControl(null);
  currentyearsofexperienceTo: UntypedFormControl = new UntypedFormControl(null);
  fromyearsofexperience: number
  toyearsofexperience: number
  currentfromyearsofexperience: number
  currenttoyearsofexperience: number
  @Output() dataEvent = new EventEmitter<string>();
  socialprofiles: any;
  professionalemail: any;
  personalemail: any;
  mobilenumber: any;
  totalCandidatesCountLoading: boolean = false
  experiencetype: string = 'Total';
  graduationError: boolean = false;
  toExperienceNotNumberError: boolean = false
  fromExperienceNotNumberError: boolean = false
  showJobTitleLoader: boolean = false
  showSkillLoader: boolean = false
  showIndustryLoader: boolean = false
  showLocationLoader: boolean = false
  showCompanyLoader: boolean = false
  showEducationLoader: boolean = false
  showFieldOfStudyLoader: boolean = false
  showSchoolLoader: boolean = false
  totaldatacount: any
  functionsInput: UntypedFormControl = new UntypedFormControl(null)
  functionsList: any = []
  showFunctionsLoader: boolean = false
  functionSelectedList: any = []
  seniorityList = GlobalService.seniorityLevels;

  //name filter
  nameInput: UntypedFormControl = new UntypedFormControl(null)
  showfullnameLoader: boolean = false
  fullnameList: any
  fullNameSelectedList: any = [];
  savedHistorySubject: Subject<any> = new Subject<any>();

  // Constant to access in template
  PAST_JOB_TITLE = "pastjobtitle";
  pastJobTitleInput: UntypedFormControl = new UntypedFormControl(null);
  pastJobTitleTopList: any;
  pastJobTitleSelectedList: any[] = [];
  pastJobTitleList: any = [];
  showPastJobTitleLoader: boolean = false;
  private continent?: string[];
  isOpenAIPastJobTitleLoading: boolean = false;
  showOpenAIPastJobTitleSuggestions: number;

  get openAIPastJobTitles() {
    return this.pastJobTitleSelectedList.filter(jt => !jt.isSuggestion).map(jobTitle => `"${jobTitle.key.replace('.searchastext', '')}"`).join(' OR ') || '';
  }

  isOpenAITitleLoading: boolean = false;
  showOpenAITitleSuggestions: number;

  aiSuggestedTitles: SuggestedTitle[] = [];
  aiSuggestedPastJobTitles: SuggestedTitle[] = [];
  aiSuggestedSkills: SuggestedTitle[] = [];

  updatedAiTitleChips: EventEmitter<SuggestedTitle[]> = new EventEmitter<SuggestedTitle[]>();
  updatedAiPastJobTitleChips: EventEmitter<SuggestedTitle[]> = new EventEmitter<SuggestedTitle[]>();
  updatedAiSkillChips: EventEmitter<SuggestedTitle[]> = new EventEmitter<SuggestedTitle[]>();

  clearAiTitleChips: EventEmitter<void> = new EventEmitter<void>();
  clearAiSkillChips: EventEmitter<void> = new EventEmitter<void>();
  clearAiPastTitleChips: EventEmitter<void> = new EventEmitter<void>();

  industryForCompanyAiSuggestions: string[] | [] = [];

  companyAiSuggestions: any[] = [];
  /**from graduation filter */
  fromgraduationyearFilter: number | string | null = null;
  /**to graduation filter */
  tograduationyearFilter: number | string | null = null;
  /**Range of graduation year filter */
  graduationYearRange = {
    min: new Date().getFullYear() - 10,
    max: new Date().getFullYear() + 5
  }


  get showCompanyAiSuggestions() {
    return this.companySelectedList.filter(c => !c.isSuggested).length;
  }

  get openAIExcludeSkills(): string[] {
    return this.skillsSelectedList.map(skill => skill.chipkey);
  }

  get openAIExcludeJobTitles(): string[] {
    return this.jobTitleSelectedList.map(jobTitle => jobTitle.chipkey);
  }

  get openAIExcludePastJobTitles(): string[] {
    return this.pastJobTitleSelectedList.map(jobTitle => jobTitle.chipkey);
  }

  get jobTitleAggregateType(): string {
    return this.jobtitletype == 'Current' ? 'current_jobtitle' : this.jobtitletype == 'Past' ? 'pastjobtitle' : 'jobtitle';
  }

  get jobTitleType(): string {
    return this.jobtitletype;
  }

  get pastJobTitleAggregateType(): string {
    return 'pastjobtitle';
  }

  get pastJobTitleType(): string {
    return "Past";
  }

  loadSuggestions: boolean = false;

  get openAITitles(): string {
    return this.jobTitleSelectedList.filter(jt => !jt.isSuggestion).map(jobTitle => `"${jobTitle.key.replace('.searchastext', '')}"`).join(' OR ') || '';
  }

  get jobtitleAndSkillAIData(): { boolean?: string | null, jobtitles?: string[], skills?: string[] } {
    const titles = this.jobTitleSelectedList.length ? this.jobTitleSelectedList.filter(jt => !jt.isSuggestion).map(jobTitle => jobTitle.key.replace('.searchastext', '')) : [];
    const pasttitle = this.pastJobTitleSelectedList.filter(jt => !jt.isSuggestion).map(jobTitle => jobTitle.key.replace('.searchastext', ''));
    return {
      boolean: null,
      jobtitles: [...titles, ...pasttitle],
      skills: this.skillsSelectedList.filter(jt => !jt.isSuggestion).map(skill => skill.key.replace('.searchastext', ''))
    }
  }

  isOpenAISkillsLoading: boolean = false;
  showOpenAISkillsSuggestions: number;

  get openAISkills(): string {
    return this.skillsSelectedList.filter(jt => !jt.isSuggestion).map(skill => `"${skill.key.replace('.searchastext', '')}"`).join(' OR ') || '';
  }

  get openAIAll(): string {
    return [this.openAITitles, this.openAISkills, this.openAIPastJobTitles].filter(s => s).join(' OR ') || '';
  }

  get selectedContinent() {
    return this.continent || [this.localstorageservice.getItem('region')];
  }


  schoolLocationInput: UntypedFormControl = new UntypedFormControl(null);
  schoolLocationList: any = [];
  schoolLocationSelectedList: any = [];
  schoolLocationTopList: any = [];
  showSchoolLocationLoader = false;
  distanceform: UntypedFormControl = new UntypedFormControl(null, [Validators.pattern("^[0-9]*$"), Validators.min(0), Validators.max(500)]);
  distancetype: UntypedFormControl = new UntypedFormControl(null);

  /**Number of  profiles in each page */
  profilesPerPage: number = 25;

  subscriptions: Array<Subscription> = [];
  subscriptionsLike: SubscriptionLike[] = [];
  recomandSubscription: Subscription;
  browserBackEvent: boolean = false;
  savehistory: boolean = true;
  keywordInput: UntypedFormControl = new UntypedFormControl(null);
  isEditing: boolean = false;
  booleanSearchString: string;
  recCandLoader: boolean = false;
  hasEuAccess: number;
  locationType: string = null;
  highLightOptions: { id: number, value: string, label: string, color: string, imageName: string }[] = [];
  /**List of filters selected from highlights */
  highlightsSelectedList: any[] = [];
  /** List of id's of selected highlights to control prime multi select*/
  highlightSelectedControl: any[] = [];
  positionHierarchyData: any[] = GlobalService.positionHierarchyData;
  positionHierarchyChipList: any[] = [];
  positionhierarchy: any[] = [];
  @Input() keywordtype: string = null;
  @Input() nlsearchKeyword: string = null;
  locationContinentList: any[] = [];
  defaultContinent: string = null;
  companySubscription: Subscription = null;
  skillSubscription: Subscription = null;


  constructor(private router: Router,
    private route: ActivatedRoute,
    private dataService: DataService,
    private locationService: Location,
    private Loadingservice: LoadingService,
    private localstorageservice: LocalStorageService,
    private personSearchService: PersonSearchService,
    private companyInsightsService: CompanyInsightsService,
    private continentHandlerService: ContinentHandlerService,
    private modalService: NgbModal,
    private eRef: ElementRef
  ) { }

  @HostListener('document:click', ['$event'])
clickOutside(event: Event) {
  if (!this.eRef.nativeElement.contains(event.target)) {
    if (this.isEditing) {
      this.selectedItem(event, 'booleansearch');
      this.isEditing = false;
    }
  }
}

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
    this.subscriptionsLike.forEach(sub => sub.unsubscribe());
  }

  ngOnInit() {
    this.defaultContinent = this.localstorageservice.getItem('defaultContinent');
    if (this.keywordtype == 'keyword') {
      this.isEditing = true;
    }

    if (this.keywordtype == 'save-input') {
      this.keywordInput.patchValue(this.nlsearchKeyword);
      this.isEditing = false;
      this.booleanSearchString = this.nlsearchKeyword;
      this.getPersonSearchRecommendedCandidates();

    }
    /** profiles per page selection */
    const preferenceArray = this.localstorageservice.getItem('userdata').preferenceData;
    preferenceArray && preferenceArray.length && preferenceArray.map(item => {
      if (item.listing_type == 'person-search' && item.preference_type == 'page-size') {
        this.profilesPerPage = item.preference_value;
      }
    })

    this.typeAheadSubject.pipe(debounceTime(500)).subscribe(({ event, type }) => {
      this.callTypeAheadSearch(event, type);
    });

    this.distancetype.patchValue('kilometers');
    this.distanceform.patchValue(20);

    if (!this.router.url.includes("filter=")) {
      this.setFilterDataInLocalStorage(true);
      this.getPersonSearchRecommendedCandidates();
    } else {
      const cacheRequest = localStorage.getItem(this.route.snapshot.queryParams.filter);
      const filterData = cjson.decompress(JSON.parse(cacheRequest))

      if (filterData == null) {
        this.clearFilters();
      }
      if (filterData?.calledFrom == 'history' || filterData?.calledFrom == 'advance') {
        this.getPersonSearchRecommendedCandidates()
       // this.loadFilterFromLocalStorage(filterData.allLists);
      } else {
        //this.loadFilterFromLocalStorage(filterData);
      }
    }

    const statemanagementSub = this.locationService.subscribe((p) => {
      this.browserBackEvent = true;
      const parsedUrl = this.router.parseUrl(p.url);
      let url = new URL(window.location.href);
      let typeValue = url.searchParams.get("type");
      if (parsedUrl.queryParams.filter && typeValue == null) {
        const cacheRequest = localStorage.getItem(parsedUrl.queryParams.filter);
        const filterData = cjson.decompress(JSON.parse(cacheRequest))
        this.loadFilterFromLocalStorage(filterData);
      }
    });
    this.subscriptionsLike.push(statemanagementSub);


    /**
     * commented for testing
     */
    //this.getAllFilters();

    const continentUpdateObs = this.continentHandlerService.continentUpdateObservable.subscribe(continent => {
      if (!this.browserBackEvent) {
        this.continent = [continent];
        this.requestObject['continentstobeincluded'] = this.selectedContinent;
        this.setFilterDataInLocalStorage();
        this.totalCandidatesCountLoading = true;
        this.personSearchService.getPersonSearchRecommendCandidates(this.requestObject).subscribe(response => {
          if (response.status == 'success') {
            this.totalCandidatesCountLoading = false;
            this.totalCandidatesCount = response.data.totalresultscount;
          }
        })
      }
    });
    this.subscriptions.push(continentUpdateObs);
    this.hasEuAccess = this.localstorageservice.getItem('hasEUPersonSearchAccess');
    this.highlightOptionsCall();
    this.getPersonSearchRecommendedCandidates();

  }

  /**
   * Used to get list of year in valid range
   * @param type type of request i.e. `to`, `from`
   * @returns
   */
  graduationYearList(type: string) {
    let start = this.graduationYearRange?.min;;
    let end = this.graduationYearRange?.max;

    if (type == 'from') {
      end = Number(this.tograduationyearFilter) || end;
    } else if (type == 'to') {
      start = Number(this.fromgraduationyearFilter) || start;
    }

    const output = [];
    for (let i = start; i <= end; i++) {
      output.push(i);
    }
    return output;
  }


  /**
   * Function will check either "Years of experience" and "current years in company filters" have valid input values or not,
   * Fucntion used to disable search button
   * @returns boolean
   */
  hasErrorExperienceFilter() {
    const x =
      ((this.currentyearsofexperienceFrom.value < 0 || this.currentyearsofexperienceFrom.value > 40 || this.currentyearsofexperienceTo.value > 40 || (this.currentyearsofexperienceTo.value != null && this.currentyearsofexperienceTo.value < 1))) ||
      ((this.currentyearsofexperienceFrom.value != null && this.currentyearsofexperienceTo.value != null) && (this.currentyearsofexperienceFrom.value > this.currentyearsofexperienceTo.value)) ||
      ((this.yearsofexperienceTo.value != null && this.yearsofexperienceFrom.value != null) && (this.yearsofexperienceFrom.value > this.yearsofexperienceTo.value)) ||
      (this.yearsofexperienceFrom.value < 0 || this.yearsofexperienceFrom.value > 40 || this.yearsofexperienceTo.value > 40 || (this.yearsofexperienceTo.value != null && this.yearsofexperienceTo.value < 1));
    return x;
  }

  typeAheadSearch(event, type: string) {
    if (this.requestObject && this.requestObject['aggregatetype']) {
      delete this.requestObject['aggregatetype']
    }

    const searchValue = (event.target as HTMLInputElement).value;

    switch (type) {
      case 'jobtitle': {
        if (searchValue.length > 2) {
          this.showJobTitleLoader = true
          this.personSearchService.getPersonSearchListing(searchValue, 'jobtitle').subscribe((response: any) => {
            if (response.status == 'success' && response.data) {
              this.jobTitleList = response.data;
              this.showJobTitleLoader = false
            }
          });
        }

        break;
      }
      case 'currentworkcity': {
        if (searchValue.length > 2) {
          this.personSearchService.getPersonSearchListing(searchValue, 'currentworkcity').subscribe((response: any) => {
            if (response.status == 'success' && response.data) {
              this.currentWorkCityList = response.data;
            }
          });
        }
        break;
      }
      case 'currentworkcountry': {
        if (searchValue.length > 2) {
          this.personSearchService.getPersonSearchListing(searchValue, 'currentworkcountry').subscribe((response: any) => {
            if (response.status == 'success' && response.data) {
              this.currentWorkCountryList = response.data;
            }
          });
        }
        break;
      }
      case 'currentworklocality': {
        if (searchValue.length > 2) {
          this.personSearchService.getPersonSearchListing(searchValue, 'currentworklocality').subscribe((response: any) => {
            if (response.status == 'success' && response.data) {
              this.currentWorkLocalityList = response.data;
            }
          });
        }
        break;
      }
      case 'skills': {
        if (searchValue.length > 0) {
          this.skillSubscription && this.skillSubscription.unsubscribe();
          this.showSkillLoader = true
          this.skillSubscription = this.personSearchService.getPersonSearchListing(searchValue, 'skill').subscribe((response: any) => {
            if (response.status == 'success' && response.data) {
              this.skillsList = response.data;
              this.showSkillLoader = false
            }
          });
        }else{
          this.showSkillLoader = false
        }
        break;
      }
      case 'company': {

        if (searchValue.length > 0) {
          this.companySubscription && this.companySubscription.unsubscribe();
          this.showCompanyLoader = true
         this.companySubscription =  this.personSearchService.getPersonSearchListing(searchValue, 'company').subscribe((response: any) => {
            if (response.status == 'success' && response.data) {
              const companyList = response.data;
              const payload = companyList.map(item => {
                if (item.value) {
                  return { name: item.value };
                }
              }).filter(Boolean);
              payload?.length &&
                this.personSearchService.getCompanyLogoV2(payload).subscribe((response: any) => {
                  this.companyList = response.data;
                  this.showCompanyLoader = false;
                });
            }
          });
        }else{
          this.showCompanyLoader = false;
        }
        break;
      }
      case 'industry': {

        if (searchValue.length > 2) {
          this.showIndustryLoader = true
          this.personSearchService.getPersonSearchListing(searchValue, 'industry').subscribe((response: any) => {
            if (response.status == 'success' && response.data) {
              this.industryList = response.data;
              this.showIndustryLoader = false
            }
          });
        }
        break;
      }
      case 'fieldofstudy': {

        if (searchValue.length > 2) {

          this.showFieldOfStudyLoader = true

          this.personSearchService.getPersonSearchListing(searchValue, 'fieldofstudy').subscribe((response: any) => {
            if (response.status == 'success' && response.data) {
              this.fieldOfStudyList = response.data;
              this.showFieldOfStudyLoader = false
            }
          });
        }
        break;
      }
      case 'companysize': {
        if (searchValue.length > 2) {
          this.personSearchService.getPersonSearchListing(searchValue, 'companysize').subscribe((response: any) => {
            if (response.status == 'success' && response.data) {
              const rangeValue = (range) => {
                const match = range.match(/(\d+)/g);
                const start = parseInt(match[0]);
                const end = parseInt(match[1]);
                return Math.floor(start / 10);
              };

              this.companySizeList = response.data.sort((a, b) => {
                const aValue = rangeValue(a.key);
                const bValue = rangeValue(b.key);
                return aValue - bValue;
              });
            }
          });
        }
        break;
      }
      case 'education': {

        if (searchValue.length > 2) {
          this.showEducationLoader = true
          this.personSearchService.getPersonSearchListing(searchValue, 'education').subscribe((response: any) => {
            if (response.status == 'success' && response.data) {
              this.educationList = response.data;
              this.showEducationLoader = false
            }
          });
        }
        break;
      }
      case 'school': {

        if (searchValue.length > 2) {
          this.showSchoolLoader = true
          this.personSearchService.getPersonSearchListing(searchValue, 'school').subscribe((response: any) => {
            if (response.status == 'success' && response.data) {
              this.schoolList = response.data;
              this.showSchoolLoader = false
            }
          });
        }
        break;
      }
      case 'location': {

        if (searchValue.length > 2) {
          this.showLocationLoader = true
          this.personSearchService.getPersonSearchListing(searchValue, 'location').subscribe((response: any) => {
            if (response.status == 'success' && response.data) {
              this.locationList = response.data;
              this.showLocationLoader = false
            }
          });
        }
        break;
      }
      case this.PAST_JOB_TITLE: {

        if (searchValue.length > 2) {
          this.showPastJobTitleLoader = true;
          this.personSearchService.getPersonSearchListing(searchValue, this.PAST_JOB_TITLE).subscribe((response: any) => {
            if (response.status == 'success' && response.data) {
              this.pastJobTitleList = response.data;
            }
            this.showPastJobTitleLoader = false;
          });
        }
        break;
      }
      case 'language': {
        if (searchValue.length > 2) {
          this.personSearchService.getPersonSearchListing(searchValue, 'spokenlanguage').subscribe((response: any) => {
            if (response.status == 'success' && response.data) {
              this.languageList = response.data;
            }
          });
        }
        break;
      }

      case 'fromyearsofexperience': {
        const fromYears = this.yearsofexperienceFrom.value
        if (!isNaN(fromYears) && Number.isInteger(fromYears)) {
          this.fromyearsofexperience = fromYears;
          if (!isNaN(this.toyearsofexperience) && this.fromyearsofexperience > this.toyearsofexperience) {
            console.error("fromyearsofexperience should be greater than toyearsofexperience");
            this.yearsofexperienceFrom.setErrors({ 'invalidYears': true });
            break;
          }
          this.yearsofexperienceFrom.setErrors(null);
          this.setFilterDataInLocalStorage();
          this.getPersonSearchRecommendedCandidates();
        } else {
          if (event.target.value == '') {
            this.yearsofexperienceFrom.setErrors(null);
            this.fromyearsofexperience = null
            this.setFilterDataInLocalStorage();
            this.getPersonSearchRecommendedCandidates();
          } else {
            //this.toExperienceNotNumberError = true
            this.yearsofexperienceFrom.setErrors({ 'invalidYears': true });
          }
        }
        break;
      }

      case 'toyearsofexperience': {
        const toYears = this.yearsofexperienceTo.value
        if (!isNaN(toYears) && Number.isInteger(toYears)) {
          this.toyearsofexperience = toYears;
          if (!isNaN(this.fromyearsofexperience) && this.toyearsofexperience <= this.fromyearsofexperience) {
            console.error("toyearsofexperience should be greater than fromyearsofexperience");
            this.yearsofexperienceTo.setErrors({ 'invalidYears': true });
            break;
          }
          this.yearsofexperienceTo.setErrors(null);
          this.setFilterDataInLocalStorage();
          this.getPersonSearchRecommendedCandidates();
        } else {
          if (event.target.value == '') {
            this.yearsofexperienceTo.setErrors(null);
            this.toyearsofexperience = null
            this.setFilterDataInLocalStorage();
            this.getPersonSearchRecommendedCandidates();
          } else {
            this.yearsofexperienceTo.setErrors({ 'invalidYears': true });
            this.fromExperienceNotNumberError = true
          }
        }
        break;
      }

      case 'functions': {

        if (searchValue.length > 2) {
          this.showFunctionsLoader = true
          this.personSearchService.getPersonSearchListing(searchValue, 'function').subscribe((response: any) => {
            if (response.status == 'success' && response.data) {
              this.functionsList = response.data;
              this.showFunctionsLoader = false
            }
          });
        }

        break;
      }

      case 'fullname': {

        if (searchValue.length > 2) {
          this.showfullnameLoader = true
          this.personSearchService.getPersonSearchListing(searchValue, 'fullname').subscribe((response: any) => {
            if (response.status == 'success' && response.data) {
              this.fullnameList = response.data;
              this.showfullnameLoader = false
            }
          });
        }

        break;
      }

      case 'currentfromyearsofexperience': {
        const fromYears = this.currentyearsofexperienceFrom.value
        if (!isNaN(fromYears) && Number.isInteger(fromYears)) {
          this.currentfromyearsofexperience = fromYears;
          if (!isNaN(this.currenttoyearsofexperience) && this.currentfromyearsofexperience > this.currenttoyearsofexperience) {
            console.error("currentfromyearsofexperience should be greater than currenttoyearsofexperience");
            this.currentyearsofexperienceFrom.setErrors({ 'invalidYears': true });
            break;
          }
          this.currentyearsofexperienceFrom.setErrors(null);
          this.setFilterDataInLocalStorage();
          this.getPersonSearchRecommendedCandidates();
        } else {
          if (event.target.value == '') {
            this.currentyearsofexperienceFrom.setErrors(null);
            this.currentfromyearsofexperience = null
            this.setFilterDataInLocalStorage();
            this.getPersonSearchRecommendedCandidates();
          } else {
            //this.toExperienceNotNumberError = true
            this.currentyearsofexperienceFrom.setErrors({ 'invalidYears': true });
          }
        }
        break;
      }

      case 'currenttoyearsofexperience': {
        const toYears = this.currentyearsofexperienceTo.value
        if (!isNaN(toYears) && Number.isInteger(toYears)) {
          this.currenttoyearsofexperience = toYears;
          if (!isNaN(this.currenttoyearsofexperience) && this.currenttoyearsofexperience <= this.currentfromyearsofexperience) {
            console.error("currenttoyearsofexperience should be greater than currentfromyearsofexperience");
            this.currentyearsofexperienceTo.setErrors({ 'invalidYears': true });
            break;
          }
          this.currentyearsofexperienceTo.setErrors(null);
          this.setFilterDataInLocalStorage();
          this.getPersonSearchRecommendedCandidates();
        } else {
          if (event.target.value == '') {
            this.currentyearsofexperienceTo.setErrors(null);
            this.currenttoyearsofexperience = null
            this.setFilterDataInLocalStorage();
            this.getPersonSearchRecommendedCandidates();
          } else {
            this.currentyearsofexperienceTo.setErrors({ 'invalidYears': true });
            this.fromExperienceNotNumberError = true
          }
        }
        break;
      }
      case 'schoollocation': {

        if (searchValue.length > 2) {
          this.showSchoolLocationLoader = true;
          this.personSearchService.getPersonSearchListing(searchValue, 'school_location').subscribe((response: any) => {
            if (response.status == 'success' && response.data) {
              this.schoolLocationList = response.data;
            }
            this.showSchoolLocationLoader = false;
          });
        }
        break;
      }
      case 'distance': {
        this.distanceform.patchValue(event.target.value);
        if (this.distanceform.valid) {
          this.setFilterDataInLocalStorage();
          this.getPersonSearchRecommendedCandidates();
        }
        break;
      }
      case 'distancetype': {
        this.distancetype.patchValue(event.target.value);
        if (this.distanceform.valid && this.distancetype.valid) {
          this.setFilterDataInLocalStorage();
          this.getPersonSearchRecommendedCandidates();
        }
        break;
      }

      case 'tograduationyear': {
        this.requestObject['tograduationyear'] = this.tograduationyearFilter;
        this.setFilterDataInLocalStorage();
        this.getPersonSearchRecommendedCandidates();
        break;
      }
      case 'fromgraduationyear': {
        this.requestObject['fromgraduationyear'] = this.fromgraduationyearFilter;
        this.setFilterDataInLocalStorage();
        this.getPersonSearchRecommendedCandidates();
        break;
      }

    }
  }

  getCompanyLogoForCompanyChips(companyList: Array<string>) {
    if (!companyList || !companyList.length) return;
    const updatedCompanyList = companyList.map(companyName => {
      const name = companyName.split(".searchastext");
      return name[0];
    }).filter(Boolean);

    const payload = [];
    updatedCompanyList.forEach(item => {
      payload.push({
        name: item
      })
    })

    this.personSearchService.getCompanyLogoV2(payload).subscribe((res: any) => {
      this.companySelectedList?.length && this.companySelectedList.map(company => {
        if (res && res.data?.length) {
          res.data.map(logosData => {
            if ((logosData.key === company.chipkey) || (logosData.key === company.key)) {
              company['companylogo'] = logosData?.companylogo;
            }
          })
        }
      })
    })
  }


  companySizeHandler(event) {
    let value = event.value;
    this.companysize = _.without(this.companysize, "All")
    // value = _.without(value, "All")
    // if (value.length == 8) {
    //   this.companysize = value;
    //   this.companysize.push(value);
    // } else {
    //   this.companysize = value;
    // }
    this.setFilterDataInLocalStorage();
    this.getPersonSearchRecommendedCandidates();
  }

  seniorityHandler(event) {
    let value = event.value;
    this.seniority = _.without(this.seniority, "All")
    this.setFilterDataInLocalStorage();
    this.getPersonSearchRecommendedCandidates();
  }

  selectedItem(event, type, contactEvent: any = null) {
    this.start = 0;
    this.currentPage = 1;
    const inputElements: NodeListOf<Element> = document.querySelectorAll(".mat-input-element");
    inputElements.forEach((element: Element) => {
      (element as HTMLInputElement).blur();
    });
    switch (type) {
      case "jobtitle": {
        this.jobTitleList = []
        if (event.option && event.option.value) {
          this.jobTitleSelectedList.push({
            ...event.option.value,
            isExcluded: false,
            isMandatory: false,
            chipkey: event.option.value.key
          });
        } else {
          this.jobTitleSelectedList.push({
            key: event.target.value + ".searchastext",
            isExcluded: false,
            isMandatory: false,
            chipkey: event.target.value
          });
          this.autocomplete.closePanel();
        }

        this.jobTitleSelectedList = _.uniq(this.jobTitleSelectedList, "key");
        this.jobTitleInput.reset();
        this.setFilterDataInLocalStorage();
        this.getPersonSearchRecommendedCandidates();
        break;
      }
      case this.PAST_JOB_TITLE: {
        this.pastJobTitleList = []
        if (event.option && event.option.value) {
          this.pastJobTitleSelectedList.push({
            ...event.option.value,
            isExcluded: false,
            isMandatory: false,
            chipkey: event.option.value.key
          });
        } else {
          this.pastJobTitleSelectedList.push({
            key: event.target.value + ".searchastext",
            isExcluded: false,
            isMandatory: false,
            chipkey: event.target.value
          });
          this.autocomplete.closePanel();
        }

        this.pastJobTitleSelectedList = _.uniq(this.pastJobTitleSelectedList, "key");
        this.pastJobTitleInput.reset();
        this.setFilterDataInLocalStorage();
        this.getPersonSearchRecommendedCandidates();
        break;
      }
      case 'currentworkcity': {
        this.currentWorkCitySelectedList.push(event.option.value);
        this.currentWorkCitySelectedList = _.uniq(this.currentWorkCitySelectedList, 'key');
        this.currentWorkCityInput.reset();
        this.setFilterDataInLocalStorage();
        this.getPersonSearchRecommendedCandidates();
        break;
      }
      case 'currentworkcountry': {
        this.currentWorkCountrySelectedList.push(event.option.value);
        this.currentWorkCountrySelectedList = _.uniq(this.currentWorkCountrySelectedList, 'key');
        this.currentWorkCountryInput.reset();
        this.setFilterDataInLocalStorage();
        this.getPersonSearchRecommendedCandidates();
        break;
      }
      case 'currentworklocality': {
        this.currentWorkLocalitySelectedList.push(event.option.value);
        this.currentWorkLocalitySelectedList = _.uniq(this.currentWorkLocalitySelectedList, 'key');
        this.currentWorkLocalityInput.reset();
        this.setFilterDataInLocalStorage();
        this.getPersonSearchRecommendedCandidates();
        break;
      }
      case 'skills': {
        this.skillsList = []
        if (event.option && event.option.value) {
          this.skillsSelectedList.push({ ...event.option.value, chipkey: event.option.value.key })
        } else {
          this.skillsSelectedList.push({ key: event.target.value + ".searchastext", chipkey: event.target.value })
          this.autocomplete.closePanel();
        }
        this.skillsSelectedList = _.uniq(this.skillsSelectedList, 'key');
        this.skillsInput.reset();
        this.setFilterDataInLocalStorage();
        this.getPersonSearchRecommendedCandidates();
        break;
      }
      case 'company': {
        this.companyList = []
        if (event.option && event.option.value) {
          this.companySelectedList.push({ ...event.option.value, chipkey: event.option.value.key })
        } else {
          this.companySelectedList.push({ key: event.target.value + ".searchastext", chipkey: event.target.value })
          this.autocomplete.closePanel();
        }
        this.companySelectedList = _.uniq(this.companySelectedList, 'key');
        this.getCompanyLogoForCompanyChips(_.pluck(this.companySelectedList, 'key'))
        const companyList = this.companySelectedList.filter(c => !c.isSuggested);
        this.companyAiSuggestions = this.companyAiSuggestions?.filter(c => !this.companySelectedList.some(cs => cs.chipkey == c.chipkey));
        this.companyInput.reset();
        if (companyList && companyList.length) {
          this.getCompanyAiSuggestions();
        }
        this.companyInput.reset();
        this.setFilterDataInLocalStorage();
        this.getPersonSearchRecommendedCandidates();
        break;
      }
      case 'industry': {
        this.industryList = []
        if (event.option && event.option.value) {
          this.industrySelectedList.push({ ...event.option.value, chipkey: event.option.value.key })
        } else {
          this.industrySelectedList.push({ key: event.target.value + ".searchastext", chipkey: event.target.value })
          this.autocomplete.closePanel();
        }
        this.industrySelectedList = _.uniq(this.industrySelectedList, 'key');
        this.industryInput.reset();
        this.setFilterDataInLocalStorage();
        this.getPersonSearchRecommendedCandidates();
        break;
      }
      case 'fieldofstudy': {
        this.fieldOfStudyList = []
        if (event.option && event.option.value) {
          this.fieldOfStudySelectedList.push({ ...event.option.value, chipkey: event.option.value.key })
        } else {
          this.fieldOfStudySelectedList.push({ key: event.target.value + ".searchastext", chipkey: event.target.value })
          this.autocomplete.closePanel();
        }
        this.fieldOfStudySelectedList = _.uniq(this.fieldOfStudySelectedList, 'key');
        this.fieldOfStudyInput.reset();
        this.setFilterDataInLocalStorage();
        this.getPersonSearchRecommendedCandidates();
        break;
      }
      case 'zipcode': {
        this.zipCodeSelectedList.push(event.option.value);
        this.zipCodeSelectedList = _.uniq(this.zipCodeSelectedList, 'key');
        this.zipCodeInput.reset();
        this.setFilterDataInLocalStorage();
        this.getPersonSearchRecommendedCandidates();
        break;
      }
      case 'companysize': {
        this.companySizeHandler(event)
        break;
      }
      case 'graduationyear': {
        this.graduationYearSelectedList.push(event.option.value);
        this.graduationYearSelectedList = _.uniq(this.graduationYearSelectedList, 'key');
        this.graduationYearInput.reset();
        this.setFilterDataInLocalStorage();
        this.getPersonSearchRecommendedCandidates();
        break;
      }
      case 'school': {
        this.schoolList = []
        if (event.option && event.option.value) {
          this.schoolSelectedList.push({ ...event.option.value, chipkey: event.option.value.key })
        } else {
          this.schoolSelectedList.push({ key: event.target.value + '.searchastext', chipkey: event.target.value })
          this.autocomplete.closePanel();
        }
        this.schoolSelectedList = _.uniq(this.schoolSelectedList, 'key');
        this.schoolInput.reset();
        this.setFilterDataInLocalStorage();
        this.getPersonSearchRecommendedCandidates();
        break;
      }
      case 'education': {
        this.educationList = []
        if (event.option && event.option.value) {
          this.educationSelectedList.push({ ...event.option.value, chipkey: event.option.value.key })
        } else {
          this.educationSelectedList.push({ key: event.target.value + '.searchastext', chipkey: event.target.value })
          this.autocomplete.closePanel();
        }
        this.educationSelectedList = _.uniq(this.educationSelectedList, 'key');
        this.educationInput.reset();
        this.setFilterDataInLocalStorage();
        this.getPersonSearchRecommendedCandidates();
        break;
      }
      case 'gender': {
        this.gender = event;
        this.setFilterDataInLocalStorage();
        this.getPersonSearchRecommendedCandidates();
        break;
      }
      case 'seniority': {
        this.seniorityHandler(event)
        break;
      }
      case 'contacts': {
        this[event] = contactEvent.target.checked
        if (event == 'candidateshavingsocialprofiles') {
          this.getAggregationReport('socialprofiles');
        } else if (event == 'candidateshavingprofessionalemail') {
          this.getAggregationReport('professionalemail');
        } else if (event == 'candidateshavingpersonalemail') {
          this.getAggregationReport('personalemail');
        } else if (event == 'candidateshavingmobilenumber') {
          this.getAggregationReport('mobilenumber');
        }

        this.setFilterDataInLocalStorage();
        this.getPersonSearchRecommendedCandidates();
        break;
      }
      case 'location': {
        this.locationInput.setValue(event.option ? event.option.value.key : event.target.value);
        if (this.hasEuAccess == 1 && event.option && event.option.value && event.option.value.continent == 'europe') {
          const euData = this.localstorageservice.getItem('euConscent');
          const now = new Date().getTime();
          if (euData) {
            const parsedData = JSON.parse(euData);
            if (!parsedData.lastShown || now - parseInt(parsedData.lastShown, 10) > 24 * 60 * 60 * 1000) {
              const modalRef = this.modalService.open(EuropeAccessModalComponent, { windowClass: 'euAccessModal', centered: true, backdrop: 'static', keyboard: false });
              modalRef.result.then((res) => {
                if (res.action == "success") {
                  this.locationList = []
                  if (event.option && event.option.value) {
                    this.locationSelectedList.push({ ...event.option.value, chipkey: event.option.value.key, location_type: event.option.value.location_type, continent: event.option.value.continent });
                    this.locationContinentList = _.uniq(_.pluck(this.locationSelectedList, 'continent'));
                  } else {
                    this.locationSelectedList.push({ key: event.target.value + '.searchastext', chipkey: event.target.value, location_type: null })
                    this.autocomplete.closePanel();
                  }
                  this.locationSelectedList = _.uniq(this.locationSelectedList, 'key');
                  const locationType = _.pluck(this.locationSelectedList, 'location_type');
                  this.locationType = locationType.length > 0 && locationType.indexOf('city') !== -1 ? 'city' : null;
                  this.locationInput.reset();
                  this.setFilterDataInLocalStorage();
                  this.getPersonSearchRecommendedCandidates();
                } else {
                  this.locationInput.reset();
                  this.locationList = []
                  this.locationType = null;
                  this.setFilterDataInLocalStorage();
                  this.getPersonSearchRecommendedCandidates();
                }
              })
            }

            else {
              this.locationList = []
              if (event.option && event.option.value) {
                this.locationSelectedList.push({ ...event.option.value, chipkey: event.option.value.key, location_type: event.option.value.location_type, continent: event.option.value.continent });
                this.locationContinentList = _.uniq(_.pluck(this.locationSelectedList, 'continent'));

              } else {
                this.locationSelectedList.push({ key: event.target.value + '.searchastext', chipkey: event.target.value, location_type: null })
                this.autocomplete.closePanel();
              }
              this.locationSelectedList = _.uniq(this.locationSelectedList, 'key');
              const locationType = _.pluck(this.locationSelectedList, 'location_type');
              this.locationType = locationType.length > 0 && locationType.indexOf('city') !== -1 ? 'city' : null;
              this.locationInput.reset();
              this.setFilterDataInLocalStorage();
              this.getPersonSearchRecommendedCandidates();
            }
          } else {
            const modalRef = this.modalService.open(EuropeAccessModalComponent, { windowClass: 'euAccessModal', centered: true, backdrop: 'static', keyboard: false });
            modalRef.result.then((res) => {
              if (res.action == "success") {
                this.locationList = []
                if (event.option && event.option.value) {
                  this.locationSelectedList.push({ ...event.option.value, chipkey: event.option.value.key, location_type: event.option.value.location_type, continent: event.option.value.continent });
                  this.locationContinentList = _.uniq(_.pluck(this.locationSelectedList, 'continent'));

                } else {
                  this.locationSelectedList.push({ key: event.target.value + '.searchastext', chipkey: event.target.value, location_type: null })
                  this.autocomplete.closePanel();
                }
                this.locationSelectedList = _.uniq(this.locationSelectedList, 'key');
                const locationType = _.pluck(this.locationSelectedList, 'location_type');
                this.locationType = locationType.length > 0 && locationType.indexOf('city') !== -1 ? 'city' : null;
                this.locationInput.reset();
                this.setFilterDataInLocalStorage();
                this.getPersonSearchRecommendedCandidates();
              } else {
                this.locationInput.reset();
                this.locationList = []
                this.locationType = null;
                this.setFilterDataInLocalStorage();
                this.getPersonSearchRecommendedCandidates();
              }
            })
          }
        } else {
          this.locationList = []
          if (event.option && event.option.value) {
            this.locationSelectedList.push({ ...event.option.value, chipkey: event.option.value.key, location_type: event.option.value.location_type, continent: event.option.value.continent });
            this.locationContinentList = _.uniq(_.pluck(this.locationSelectedList, 'continent'));

          } else {
            this.locationSelectedList.push({ key: event.target.value + '.searchastext', chipkey: event.target.value, location_type: null })
            this.autocomplete.closePanel();
          }
          this.locationSelectedList = _.uniq(this.locationSelectedList, 'key');
          const locationType = _.pluck(this.locationSelectedList, 'location_type');
          this.locationType = locationType.length > 0 && locationType.indexOf('city') !== -1 ? 'city' : null;
          this.locationInput.reset();
          this.setFilterDataInLocalStorage();
          this.getPersonSearchRecommendedCandidates();
        }

        break;
      }
      case 'language': {
        this.languageSelectedList.push(event.option.value);
        this.languageSelectedList = _.uniq(this.languageSelectedList, 'key');
        this.languageInput.reset();
        this.setFilterDataInLocalStorage();
        this.getPersonSearchRecommendedCandidates();
        break;
      }
      case 'functions': {
        this.functionsList = []
        if (event.option && event.option.value) {
          this.functionSelectedList.push({ ...event.option.value, chipkey: event.option.value.key })
        } else {
          this.functionSelectedList.push({ key: event.target.value + '.searchastext', chipkey: event.target.value })
          this.autocomplete.closePanel();
        }
        this.functionSelectedList = _.uniq(this.functionSelectedList, 'key');
        this.functionsInput.reset();
        this.setFilterDataInLocalStorage();
        this.getPersonSearchRecommendedCandidates();
        break;
      }
      case 'fullname': {
        this.fullnameList = []
        if (event.option && event.option.value) {
          this.fullNameSelectedList.push({ ...event.option.value, chipkey: event.option.value.key })
        } else {
          this.fullNameSelectedList.push({ key: event.target.value + '.searchastext', chipkey: event.target.value })
          this.autocomplete.closePanel();
        }
        this.fullNameSelectedList = _.uniq(this.fullNameSelectedList, 'key');
        this.nameInput.reset();
        this.setFilterDataInLocalStorage();
        this.getPersonSearchRecommendedCandidates();
        break;
      }
      case 'schoollocation': {
        this.schoolLocationList = []
        if (event.option && event.option.value) {
          this.schoolLocationSelectedList.push({ ...event.option.value, chipkey: event.option.value.key })
        } else {
          this.schoolLocationSelectedList.push({ key: event.target.value + '.searchastext', chipkey: event.target.value })
          this.autocomplete.closePanel();
        }
        this.schoolLocationSelectedList = _.uniq(this.schoolLocationSelectedList, 'key');
        this.schoolLocationInput.reset();
        this.setFilterDataInLocalStorage();
        this.getPersonSearchRecommendedCandidates();
        break;
      }
      case 'booleansearch': {
        this.booleanSearchString = this.keywordInput.value;
        this.isEditing = false;
        this.setFilterDataInLocalStorage();
        this.getPersonSearchRecommendedCandidates();
        break;
      }
      case 'positionhierarchy': {
        let value = event.value;
        this.positionhierarchy = _.without(this.positionhierarchy, "All")
        value = _.without(value, "All")
        if (value.length == 10) {
          this.positionhierarchy = value;
          this.positionhierarchy.push("All")
        } else {
          this.positionhierarchy = _.uniq(this.positionhierarchy.concat(value));
        }
        this.setFilterDataInLocalStorage();
        this.getPersonSearchRecommendedCandidates();
        break;
      }
    }

    if (type != 'jobtitle' && type != 'skills' && type != this.PAST_JOB_TITLE && !this.openAIAll && type != 'fullname' && type != 'gender') {
      this.removeAllAiSuggestion();
    }
  }

  addToSelectedList(item, type) {
    switch (type) {
      case 'jobtitle': {
        this.jobTitleSelectedList.push({ ...item, isExcluded: false, isMandatory: false });
        this.jobTitleSelectedList = _.uniq(this.jobTitleSelectedList, 'key');
        this.jobTitleInput.reset();
        this.setFilterDataInLocalStorage();
        this.getPersonSearchRecommendedCandidates();
        break;
      }
      case 'company': {
        this.companySelectedList.push({ ...item, isExcluded: false, isMandatory: false });
        this.companySelectedList = _.uniq(this.companySelectedList, 'key');
        this.companyAiSuggestions = this.companyAiSuggestions?.filter(c => !this.companySelectedList.some(cs => cs.chipkey == c.chipkey));

        if (!item.isSuggested) {
          const companyList = this.companySelectedList.filter(c => !c.isSuggested);
          if (companyList && companyList.length) {
            this.getCompanyAiSuggestions();
          }
        }
        this.companyInput.reset();
        this.setFilterDataInLocalStorage();
        this.getPersonSearchRecommendedCandidates();
        break;
      }
    }
  }



  getPersonSearchRecommendedCandidates() {
    this.recCandLoader = true;
    this.recomandSubscription?.unsubscribe();
    this.requestObject = {
      startindex: this.start,
      resultsize: this.profilesPerPage,
      searchviaboolean: true,
      booleanquery: this.booleanSearchString ? this.booleanSearchString : "*",
      iscurrent: false,
      currentcompaniesonly: false,
      pastcompaniesonly: false,
      jobtitles: this.jobTitleSelectedList.map(jobTitle => jobTitle.key),
      pastjobtitles: _.uniq(this.pastJobTitleSelectedList.filter(jobTitle => !jobTitle.isExcluded).map(j => j.key)),
      exclude_pastjobtitles: _.uniq(this.pastJobTitleSelectedList.filter(jobTitle => !!jobTitle.isExcluded).map(j => j.key)),
      preferredskills: this.skillsSelectedList.map(skill => skill.key),
      mandatoryskills: [],
      companies: this.companySelectedList.map(c => c.key),
      industries: this.industrySelectedList.map(industry => industry.key),
      exclusionlist: [],
      genders: this.gender != '' ? this.gender && this.gender.length ? [this.gender] : [] : [],
      seniority: this.seniority.length ? this.seniority : [],
      schools: this.schoolSelectedList.map(s => s.key),
      schooltypes: [],
      educationaldegrees: this.educationSelectedList.map(e => e.key),
      educationalmajors: this.fieldOfStudySelectedList.map(fs => fs.key),
      candidateshavingemails: false,
      candidateshavingcontactnumbers: false,
      minexperience: null,
      maxexperience: null,
      minexperienceinccurrentcompany: null,
      zipcodes: this.zipCodeSelectedList.map(z => z.key),
      companysizes: this.companysize.length ? this.companysize : [],
      candidateshavingcontacts: false,
      workregions: this.currentWorkCitySelectedList.map(wc => wc.key),
      workcountries: this.currentWorkCountrySelectedList.map(wc => wc.key),
      worklocalities: this.currentWorkLocalitySelectedList.map(c => c.key),
      spokenlanguages: this.languageSelectedList.map(l => l.key),
      contacts: [],
      candidateshavingmobilenumber: this.candidateshavingmobilenumber,
      candidateshavingpersonalemail: this.candidateshavingpersonalemail,
      candidateshavingprofessionalemail: this.candidateshavingprofessionalemail,
      candidateshavingsocialprofiles: this.candidateshavingsocialprofiles,
      companytype: this.companytype == 'Current or Past' ? 'All' : this.companytype,
      jobtitletype: this.jobtitletype == 'Current or Past' ? 'All' : this.jobtitletype,
      industrytype: this.industrytype == 'Current or Past' ? 'All' : this.industrytype,
      experiencetype: this.experiencetype,
      fromyearsofexperience: this.fromyearsofexperience != null ? [this.fromyearsofexperience] : [],
      toyearsofexperience: this.toyearsofexperience != null ? [this.toyearsofexperience] : [],
      locations: this.locationSelectedList.length > 0 ? this.locationSelectedList.map(l => l.key) : this.geoIpLocation && this.geoIpLocation.continent == this.localstorageservice.getItem('defaultContinent') ? [`${this.geoIpLocation.location}.iplocation`] : [this.localstorageservice.getItem('defaultContinent')],
      continentstobeincluded: this.locationContinentList?.length ? this.locationContinentList : [this.localstorageservice.getItem('defaultContinent')],
      functions: this.functionSelectedList.map(fn => fn.key),
      fullnames: this.fullNameSelectedList.map(nm => nm.key),
      searchedfrom: 'advanced-search',
      currentfromyearsofexperience: this.currentfromyearsofexperience != null ? [this.currentfromyearsofexperience] : [],
      currenttoyearsofexperience: this.currenttoyearsofexperience != null ? [this.currenttoyearsofexperience] : [],

      schoollocation: _.uniq(this.schoolLocationSelectedList.filter(jobTitle => !jobTitle.isExcluded).map(j => j.key)),
      exclude_schoollocation: _.uniq(this.schoolLocationSelectedList.filter(jobTitle => !!jobTitle.isExcluded).map(j => j.key)),
      needcuratedtalentpooltags: true,
      distancefromselectedlocations: Number(this.distanceform.value),
      distancefromselectedlocationsmeasurementunit: this.distancetype.value,
      tograduationyear: this.tograduationyearFilter,
      fromgraduationyear: this.fromgraduationyearFilter,
      savehistory: this.savehistory,
      profilehighlights: _.pluck(this.highlightsSelectedList, 'value'),
      positionhierarchies: this.positionhierarchy,
      module: 'personsearch',



    }

    this.requestObject.toyearsofexperience = _.flatten(this.requestObject?.toyearsofexperience);
    this.requestObject.fromyearsofexperience = _.flatten(this.requestObject?.fromyearsofexperience);
    this.requestObject.currenttoyearsofexperience = _.flatten(this.requestObject?.currenttoyearsofexperience);
    this.requestObject.currentfromyearsofexperience = _.flatten(this.requestObject?.currentfromyearsofexperience);

    if (!(this.requestObject?.toyearsofexperience?.length && this.requestObject?.fromyearsofexperience?.length) &&
      (this.requestObject?.toyearsofexperience?.length || this.requestObject?.fromyearsofexperience?.length)) {
      if (!this.requestObject?.toyearsofexperience?.length) {
        this.requestObject.toyearsofexperience = [40];
      } else if (!this.requestObject?.fromyearsofexperience?.length) {
        this.requestObject.fromyearsofexperience = [0];
      }
    }

    if (!(this.requestObject?.currenttoyearsofexperience?.length && this.requestObject?.currentfromyearsofexperience?.length) &&
      (this.requestObject?.currenttoyearsofexperience?.length || this.requestObject?.currentfromyearsofexperience?.length)) {
      if (!this.requestObject?.currenttoyearsofexperience?.length) {
        this.requestObject.currenttoyearsofexperience = [40];
      } else if (!this.requestObject?.currentfromyearsofexperience?.length) {
        this.requestObject.currentfromyearsofexperience = [0];
      }
    }
    const loadn = document.querySelectorAll<HTMLElement>('.loading-screen-wrapper');

    this.totalCandidatesCountLoading = true;

    this.recomandSubscription = this.personSearchService.getRecommendCount(this.requestObject).subscribe(response => {
      this.recCandLoader = false;
      if (response.status == 'success') {
        this.totalCandidatesCount = response.data.totalresultscount;
      }
    });
  }

  filterByStatus(event, type) {
    if (event.target.value == 'Current or Past') {
      event.target.value = 'All'
    }
    switch (type) {
      case 'jobtitle': {
        this.jobtitletype = event.target.value;
        this.setFilterDataInLocalStorage();
        this.getPersonSearchRecommendedCandidates();
        break;
      }
      case 'company': {
        this.companytype = event.target.value;
        this.setFilterDataInLocalStorage();
        this.getPersonSearchRecommendedCandidates();
        break;
      }
      case 'industry': {
        this.industrytype = event.target.value;
        this.setFilterDataInLocalStorage();
        this.getPersonSearchRecommendedCandidates();
        break;
      }
      case 'experiencetype': {
        this.experiencetype = event.target.value;
        this.setFilterDataInLocalStorage();
        this.getPersonSearchRecommendedCandidates();
        break;

      }
    }
  }

  removeChip(value, type) {
    this.start = 0;
    this.currentPage = 1;
    const inputElements: NodeListOf<Element> = document.querySelectorAll('.mat-input-element');
    inputElements.forEach((element: Element) => {
      (element as HTMLInputElement).blur();
    });
    switch (type) {
      case 'jobtitle':
        this.jobTitleSelectedList = this.jobTitleSelectedList.filter(item => item.key !== value.key);
        this.setFilterDataInLocalStorage();
        this.getPersonSearchRecommendedCandidates();
        break;
      case this.PAST_JOB_TITLE:
        this.pastJobTitleSelectedList = this.pastJobTitleSelectedList.filter(item => item.key !== value.key);
        this.setFilterDataInLocalStorage();
        this.getPersonSearchRecommendedCandidates();
        break;
      case 'currentworkcity':
        this.currentWorkCitySelectedList = this.currentWorkCitySelectedList.filter(item => item.key !== value.key);
        this.setFilterDataInLocalStorage();
        this.getPersonSearchRecommendedCandidates();
        break;
      case 'currentworkcountry':
        this.currentWorkCountrySelectedList = this.currentWorkCountrySelectedList.filter(item => item.key !== value.key);
        this.setFilterDataInLocalStorage();
        this.getPersonSearchRecommendedCandidates();
        break;
      case 'currentworklocality':
        this.currentWorkLocalitySelectedList = this.currentWorkLocalitySelectedList.filter(item => item.key !== value.key);
        this.setFilterDataInLocalStorage();
        this.getPersonSearchRecommendedCandidates();
        break;
      case 'skills':
        this.skillsSelectedList = this.skillsSelectedList.filter(item => item.key !== value.key);
        this.setFilterDataInLocalStorage();
        this.getPersonSearchRecommendedCandidates();
        break;
      case 'company':
        this.companySelectedList = this.companySelectedList.filter(item => item.key !== value.key);
        this.setFilterDataInLocalStorage();
        this.getPersonSearchRecommendedCandidates();
        !value.isSuggested && this.companySelectedList.filter(c => !c.isSuggested).length && this.getCompanyAiSuggestions();
        break;
      case 'industry':
        this.industrySelectedList = this.industrySelectedList.filter(item => item.key !== value.key);
        this.setFilterDataInLocalStorage();
        this.getPersonSearchRecommendedCandidates();
        break;
      case 'fieldofstudy':
        this.fieldOfStudySelectedList = this.fieldOfStudySelectedList.filter(item => item.key !== value.key);
        this.setFilterDataInLocalStorage();
        this.getPersonSearchRecommendedCandidates();
        break;
      case 'zipcode':
        this.zipCodeSelectedList = this.zipCodeSelectedList.filter(item => item.key !== value.key);
        this.setFilterDataInLocalStorage();
        this.getPersonSearchRecommendedCandidates();
        break;

      case 'graduationyear':
        this.graduationYearSelectedList = this.graduationYearSelectedList.filter(item => item.key !== value.key);
        this.setFilterDataInLocalStorage();
        this.getPersonSearchRecommendedCandidates();
        break;
      case 'school':
        this.schoolSelectedList = this.schoolSelectedList.filter(item => item.key !== value.key);
        this.setFilterDataInLocalStorage();
        this.getPersonSearchRecommendedCandidates();
        break;
      case 'education':
        this.educationSelectedList = this.educationSelectedList.filter(item => item.key !== value.key);
        this.setFilterDataInLocalStorage();
        this.getPersonSearchRecommendedCandidates();
        break;
      case 'location':
        this.locationSelectedList = this.locationSelectedList.filter(item => item.key !== value.key);
        const locationType = _.pluck(this.locationSelectedList, 'location_type');
        this.locationType = locationType.length > 0 && locationType.indexOf('city') !== -1 ? 'city' : null;
        this.locationContinentList = _.uniq(_.pluck(this.locationSelectedList, 'continent'));
        this.setFilterDataInLocalStorage();
        this.getPersonSearchRecommendedCandidates();
        break;
      case 'language':
        this.languageSelectedList = this.languageSelectedList.filter(item => item.key !== value.key);
        this.setFilterDataInLocalStorage();
        this.getPersonSearchRecommendedCandidates();
        break;
      case 'functions':
        this.functionSelectedList = this.functionSelectedList.filter(item => item.key !== value.key);
        this.setFilterDataInLocalStorage();
        this.getPersonSearchRecommendedCandidates();
        break;
      case 'fullname':
        this.fullNameSelectedList = this.fullNameSelectedList.filter(item => item.key !== value.key);
        this.setFilterDataInLocalStorage();
        this.getPersonSearchRecommendedCandidates();
        break;
      case 'companysize':
        if (value === "All") {
          this.companysize = [];
        } else {
          this.companysize = this.companysize.filter(item => item !== value);
        }
        this.setFilterDataInLocalStorage();
        this.getPersonSearchRecommendedCandidates();
        break;
      case 'seniority':
        if (value === "All") {
          this.seniority = [];
        } else {
          this.seniority = this.seniority.filter(item => item !== value);
        }
        this.setFilterDataInLocalStorage();
        this.getPersonSearchRecommendedCandidates();
        break;
      case 'schoollocation':
        this.schoolLocationSelectedList = this.schoolLocationSelectedList.filter(item => item.key !== value.key);
        this.setFilterDataInLocalStorage();
        this.getPersonSearchRecommendedCandidates();
        break;
      case 'highlight':
        this.highlightsSelectedList = this.highlightsSelectedList.filter(item => item.id != value.id)
        this.highlightSelectedControl = _.pluck(this.highlightsSelectedList, 'id');
        this.setFilterDataInLocalStorage();
        this.getPersonSearchRecommendedCandidates();
        break;
      case 'positionhierarchy':
        if (value === "All")
          this.positionhierarchy = [];
        else
          this.positionhierarchy = this.positionhierarchy.filter(item => item !== value);
        this.setFilterDataInLocalStorage();
        this.getPersonSearchRecommendedCandidates();
        break;
    }
  }

  getAllFilters() {
    this.requestObject = {
      startindex: this.start,
      resultsize: 10,
      searchviaboolean: false,
      booleanquery: "*",
      iscurrent: false,
      currentcompaniesonly: false,
      pastcompaniesonly: false,
      jobtitles: [],
      preferredskills: [],
      mandatoryskills: [],
      locations: [],
      companies: [],
      industries: [],
      exclusionlist: [],
      genders: [],
      seniority: [],
      graduationyear: [],
      schools: [],
      schooltypes: [],
      educationaldegrees: [],
      educationalmajors: [],
      candidateshavingemails: false,
      candidateshavingcontactnumbers: false,
      minexperience: null,
      maxexperience: null,
      minexperienceinccurrentcompany: null,
      zipcodes: [],
      companysizes: this.companysize ? [this.companysize] : [],
      candidateshavingcontacts: false,
      workregions: this.currentWorkCitySelectedList.map(wc => wc.key),
      workcountries: this.currentWorkCountrySelectedList.map(wc => wc.key),
      worklocalities: this.currentWorkLocalitySelectedList.map(c => c.key),
      spokenlanguages: this.languageSelectedList.map(l => l.key),
      contacts: [],
      candidateshavingmobilenumber: this.candidateshavingmobilenumber,
      candidateshavingpersonalemail: this.candidateshavingpersonalemail,
      candidateshavingprofessionalemail: this.candidateshavingprofessionalemail,
      candidateshavingsocialprofiles: this.candidateshavingsocialprofiles,
      continentstobeincluded: this.selectedContinent,
      tograduationyear: null,
      fromgraduationyear: null,
      functions: []
    }
    this.personSearchService.getPersonSearchRecommendCandidates(this.requestObject).subscribe(response => {
      if (response.status == 'success') {
        this.totalCandidatesCount = response.data.totalresultscount
        this.jobTitleList = response.data.aggregations.jobtitle
        this.industryList = response.data.aggregations.industry
        this.skillsList = response.data.aggregations.skills
        this.locationList = response.data.aggregations.location
        this.companyList = response.data.aggregations.company
        this.educationList = response.data.aggregations.education
        this.fieldOfStudyList = response.data.aggregations.fieldofstudy
        this.schoolList = response.data.aggregations.school
        this.socialprofiles = response.data.aggregations.socialprofiles
        this.professionalemail = response.data.aggregations.professionalemail
        this.personalemail = response.data.aggregations.personalemail
        this.mobilenumber = response.data.aggregations.mobilenumber
        this.functionsList = response.data.aggregations.functions
        const loadn = document.querySelectorAll<HTMLElement>('.loading-screen-wrapper');
        this.getTotalAggs();
      }
    });
  }

  sendDataToParent() {
    this.modalService.dismissAll();
    const contactsAvailableArray = [];

    if (this.personalemail && this.personalemail.hasOwnProperty('doc_count')) {
      contactsAvailableArray.push({
        key: 'Personal Email',
        doc_count: this.personalemail.doc_count,
      });
    }

    // Similarly, you can do the same for other properties and add them to the array.
    // For example:
    if (this.professionalemail && this.professionalemail.hasOwnProperty('doc_count')) {
      contactsAvailableArray.push({
        key: 'Current Professional Email',
        doc_count: this.professionalemail.doc_count,
      });
    }

    if (this.mobilenumber && this.mobilenumber.hasOwnProperty('doc_count')) {
      contactsAvailableArray.push({
        key: 'Mobile Number',
        doc_count: this.mobilenumber.doc_count,
      });
    }

    if (this.socialprofiles && this.socialprofiles.hasOwnProperty('doc_count')) {
      contactsAvailableArray.push({
        key: 'Social Profiles',
        doc_count: this.socialprofiles.doc_count,
      });
    }


    const contactSelectedList = []

    if (this.candidateshavingpersonalemail && this.candidateshavingpersonalemail == true) {
      contactSelectedList.push({
        key: 'Personal Email',
        doc_count: this.personalemail.doc_count,
      });
    }

    // Similarly, you can do the same for other properties and add them to the array.
    // For example:
    if (this.candidateshavingprofessionalemail && this.candidateshavingprofessionalemail == true) {
      contactSelectedList.push({
        key: 'Current Professional Email',
        doc_count: this.professionalemail.doc_count,
      });
    }

    if (this.candidateshavingmobilenumber && this.candidateshavingmobilenumber == true) {
      contactSelectedList.push({
        key: 'Mobile Number',
        doc_count: this.mobilenumber.doc_count,
      });
    }

    if (this.candidateshavingsocialprofiles && this.candidateshavingsocialprofiles == true) {
      contactSelectedList.push({
        key: 'Social Profiles',
        doc_count: this.socialprofiles.doc_count,
      });
    }

    this.skillsSelectedList = this.skillsSelectedList.map(item => {
      return {
        ...item,
        isMandatory: false,
        isSuggested: item.isSuggestion
      };
    });

    this.companySelectedList = this.companySelectedList.map(item => {
      return {
        ...item,
        isExcluded: false
      };
    })

    this.locationSelectedList = this.locationSelectedList.map(item => {
      return {
        ...item,
        isExcluded: false
      };
    })

    this.industrySelectedList = this.industrySelectedList.map(item => {
      return {
        ...item,
        isExcluded: false
      };
    })

    const locationContinents = this.locationSelectedList.map(item => {
      return{
        key: item.key,
        continent: item.continent,
        calledFrom: 'Filter'

      }
    })
    this.booleanSearchString = this.keywordInput.value;
    const allLists = {
      jobTitleSelectedList: this.jobTitleSelectedList.map(j => ({ ...j, isSuggested: j.isSuggestion })),
      skillsSelectedList: this.skillsSelectedList,
      industrySelectedList: this.industrySelectedList,
      locationSelectedList: this.locationSelectedList,
      companySelectedList: this.companySelectedList,
      educationSelectedList: this.educationSelectedList,
      fieldOfStudySelectedList: this.fieldOfStudySelectedList,
      schoolSelectedList: this.schoolSelectedList,
      gender: this.gender,
      contactsAvailableArray: contactsAvailableArray,
      contactSelectedList: contactSelectedList,
      yearsofexperienceFrom: this.fromyearsofexperience,
      yearsofexperienceTo: this.toyearsofexperience,
      companyStatus: this.companytype && this.companytype.toString().toLocaleLowerCase() === 'all' ? 'Current or Past' : this.companytype,
      jobTitleStatus: this.jobtitletype && this.jobtitletype.toString().toLocaleLowerCase() === 'all' ? 'Current or Past' : this.jobtitletype,
      industryStatus: this.industrytype && this.industrytype.toString().toLocaleLowerCase() === 'all' ? 'Current or Past' : this.industrytype,
      yearsofexperience: this.experiencetype,
      companysize: this.companysize,
      functionSelectedList: this.functionSelectedList,
      seniority: this.seniority,
      fullNameSelectedList: this.fullNameSelectedList,
      currentfromyearsofexperience: this.currentfromyearsofexperience,
      currenttoyearsofexperience: this.currenttoyearsofexperience,
      pastJobTitleSelectedList: this.pastJobTitleSelectedList.map(j => ({ ...j, isSuggested: j.isSuggestion })),
      schoolLocationSelectedList: this.schoolLocationSelectedList,
      distancefromselectedlocations: Number(this.distanceform.value),
      distancefromselectedlocationsmeasurementunit: this.distancetype.value,
      fromgraduationyear: this.fromgraduationyearFilter,
      tograduationyear: this.tograduationyearFilter,
      savehistory: this.savehistory,
      booleanquery: this.booleanSearchString ? this.booleanSearchString : "*",
      positionhierarchies: this.positionhierarchy,
      profilehighlights: _.pluck(this.highlightsSelectedList, 'value'),
      continentstobeincluded: this.locationContinentList?.length ? this.locationContinentList : [this.localstorageservice.getItem('defaultContinent')],
      locationcontinents: locationContinents

    };

    const data = {
      allLists,
      requestObject: this.requestObject,
      calledFrom: 'advance',
    }

    this.dataService.setData(data);
    const searchParams = {
      "User ID": this.localstorageservice.getItem('userdata').userid,
      "Search Type": "Advance",
      "Time": moment().format()
    }
    clevertap.event.push('Search Initiated', searchParams);
    console.log("Search Boolean Initiated CT Event");
    const localKey = GlobalService.hash(JSON.stringify(cjson.compress(data)))
    localStorage.setItem(localKey, JSON.stringify(cjson.compress(data)));
    this.router.navigate(['/person/search/listing'], { queryParams: { filter: localKey, keyword: this.booleanSearchString ? this.booleanSearchString : '*', type: 'advanced-search' } });
  }

  private callTypeAheadSearch(event: Event, type: string) {
    this.typeAheadSearch(event, type);
  }

  // Call this function whenever the user types something
  onTypeAheadSearch(event: Event, type: string) {
    // Emit the event and type as an object through the typeAheadSubject to apply debounce
    this.typeAheadSubject.next({ event, type });
  }

  clearFilters() {
    this.totalCandidatesCount = 0
    this.jobTitleSelectedList = []
    this.pastJobTitleSelectedList = []
    this.skillsSelectedList = []
    this.industrySelectedList = []
    this.locationSelectedList = []
    this.companySelectedList = []
    this.educationSelectedList = []
    this.fieldOfStudySelectedList = []
    this.schoolSelectedList = []
    this.functionSelectedList = []
    this.fullNameSelectedList = []
    this.gender = 'All'
    this.candidateshavingmobilenumber = null
    this.candidateshavingpersonalemail = null
    this.candidateshavingprofessionalemail = null
    this.candidateshavingsocialprofiles = null
    this.jobtitletype = 'Current'
    this.experiencetype = 'Total'
    this.companytype = 'Current'
    this.industrytype = 'Current'
    this.fromyearsofexperience = null
    this.toyearsofexperience = null
    this.tograduationyearFilter = null;
    this.fromgraduationyearFilter = null;
    this.yearsofexperienceFrom.patchValue(null)
    this.yearsofexperienceTo.patchValue(null)
    this.companysize = [];
    this.seniority = [],
      this.distanceform.patchValue(20);
    this.distancetype.patchValue('kilometers');
    this.positionHierarchyChipList = [];
    this.positionhierarchy = [];
    this.highlightsSelectedList = [];

    this.requestObject = {
      startindex: this.start,
      resultsize: this.profilesPerPage,
      searchviaboolean: false,
      booleanquery: "*",
      iscurrent: false,
      currentcompaniesonly: false,
      pastcompaniesonly: false,
      jobtitles: [],
      preferredskills: [],
      mandatoryskills: [],
      companies: [],
      industries: [],
      exclusionlist: [],
      genders: [],
      seniority: [],
      graduationyear: [],
      schools: [],
      schooltypes: [],
      educationaldegrees: [],
      educationalmajors: [],
      candidateshavingemails: false,
      candidateshavingcontactnumbers: false,
      minexperience: null,
      maxexperience: null,
      minexperienceinccurrentcompany: null,
      zipcodes: [],
      companysizes: [],
      candidateshavingcontacts: false,
      workregions: this.currentWorkCitySelectedList.map(wc => wc.key),
      workcountries: this.currentWorkCountrySelectedList.map(wc => wc.key),
      worklocalities: this.currentWorkLocalitySelectedList.map(c => c.key),
      spokenlanguages: this.languageSelectedList.map(l => l.key),
      contacts: [],
      candidateshavingmobilenumber: this.candidateshavingmobilenumber,
      candidateshavingpersonalemail: this.candidateshavingpersonalemail,
      candidateshavingprofessionalemail: this.candidateshavingprofessionalemail,
      candidateshavingsocialprofiles: this.candidateshavingsocialprofiles,
      jobtitletype: 'Current',
      experiencetype: 'Total',
      companytype: 'Current',
      industrytype: 'Current',
      fromyearsofexperience: [],
      toyearsofexperience: [],
      locations: [],
      continentstobeincluded: [],
      functions: [],
      fullnames: [],
      currentfromyearsofexperience: [],
      currenttoyearsofexperience: [],
      tograduationyear: null,
      fromgraduationyear: null,
      distancefromselectedlocations: this.distanceform.value,
      distancefromselectedlocationsmeasurementunit: this.distancetype.value,
      module: 'personsearch'
    }

    this.totalCandidatesCountLoading = true;
    this.personSearchService.getRecommendCount(this.requestObject).subscribe(response => {
      if (response.status == 'success') {
        this.totalCandidatesCountLoading = false;
        this.totalCandidatesCount = response.data.totalresultscount;
      }
    });

  }

  // not in indian format
  formatNumberToIndianFormat(number) {
    if (number) {
      const suffixes = ['', 'K+', 'M+', 'B+', 'T+']; // Add more suffixes as needed for larger numbers
      for (const suffix of suffixes) {
        if (Math.abs(number) < 1000) {
          return Math.floor(number) + suffix;
        }
        number /= 1000;
      }
      return Math.floor(number) + 'T';
    } else {
      return 0;
    }
  }

  getTotalAggs() {
    this.getAggregationReport('gender');
    this.getAggregationReport('company');
    this.getAggregationReport('pastcompany');
    this.getAggregationReport('school');
    this.getAggregationReport('current_industry');
    this.getAggregationReport('pastindustry');
    this.getAggregationReport('industry');
    this.getAggregationReport('current_jobtitle');
    this.getAggregationReport('pastjobtitle');
    this.getAggregationReport('jobtitle');
    this.getAggregationReport('skills');
    this.getAggregationReport('fieldofstudy');
    this.getAggregationReport('education');
    this.getAggregationReport('mobilenumber');
    this.getAggregationReport('professionalemail');
    this.getAggregationReport('personalemail');
    this.getAggregationReport('socialprofiles');
  }

  getAggregationReport(aggregatetype: string) {
    this.requestObject['aggregatetype'] = aggregatetype;
    this.personSearchService.getTotalAggs(this.requestObject).subscribe(response => {
      if (response.status == 'success') {
        this.jobTitleList = this.jobTitleList === undefined ? response.data.aggregations.current_jobtitle : this.jobTitleList;
        this.industryList = this.industryList === undefined ? response.data.aggregations.current_industry : this.industryList;
        this.skillsList = this.skillsList === undefined ? response.data.aggregations.skills : this.skillsList;
        this.locationList = this.locationList === undefined ? response.data.aggregations.location : this.locationList;
        this.companyList = this.companyList === undefined ? response.data.aggregations.company : this.companyList;
        this.educationList = this.educationList === undefined ? response.data.aggregations.education : this.educationList;
        this.fieldOfStudyList = this.fieldOfStudyList === undefined ? response.data.aggregations.fieldofstudy : this.fieldOfStudyList;
        this.schoolList = this.schoolList === undefined ? response.data.aggregations.school : this.schoolList;

        this.socialprofiles = this.socialprofiles === undefined ? response.data.aggregations.socialprofiles : this.socialprofiles;
        this.professionalemail = this.professionalemail === undefined ? response.data.aggregations.professionalemail : this.professionalemail;
        this.personalemail = this.personalemail === undefined ? response.data.aggregations.personalemail : this.personalemail;
        this.mobilenumber = this.mobilenumber === undefined ? response.data.aggregations.mobilenumber : this.mobilenumber;

      }
    });
  }

  getrecordcount() {
    this.personSearchService.getrecordsCount().subscribe((res: any) => {
      this.totalCandidatesCount = res.data;
    })
  }

  checkHistory(event) {
    if (event === 'REFRESH') {
      this.savedHistorySubject.next(event);
    }
  }

  openaiTitleLoading({ state, count, suggested }) {
    this.isOpenAITitleLoading = state;
    this.showOpenAITitleSuggestions = count;

    suggested && (this.aiSuggestedTitles = suggested);
    this.openAIAll && !state && (suggested !== undefined && suggested !== null) && suggested.length < 5 && this.getFilterWiseDataToDisplay('pastjobtitle', true);
  }

  setTitleSuggestions(suggestions: SuggestedTitle[]) {
    // generate key for each suggestion
    const suggestionsWithKey = suggestions.map(suggestion => {
      return {
        key: `${suggestion.name}.aisearch`,
        chipkey: suggestion.name,
        isExcluded: false,
        isMandatory: false,
        isSuggestion: true,
        suggestedTitle: { name: suggestion.name, selected: true, type: 'title', key: this.getSafeKey(suggestion.name) }
      };
    });
    // existing suggestions
    const existingSuggestions = this.jobTitleSelectedList.filter(suggestion => suggestion.isSuggestion);
    // remove existing suggestions from new suggestions
    const newSuggestions = suggestionsWithKey.filter(suggestion => !existingSuggestions.find(existingSuggestion => existingSuggestion.chipkey === suggestion.chipkey));
    // add new suggestions to existing suggestions
    this.jobTitleSelectedList.push(...newSuggestions);
    if (newSuggestions.length) {
      this.setFilterDataInLocalStorage();
      this.getPersonSearchRecommendedCandidates();
    }
  }

  openaiSkillsLoading({ state, count, suggested }) {
    this.isOpenAISkillsLoading = state;
    this.showOpenAISkillsSuggestions = count;

    suggested && (this.aiSuggestedSkills = suggested);
    this.openAIAll && !state && (suggested !== undefined && suggested !== null) && suggested.length < 5 && this.getFilterWiseDataToDisplay('skills', true);

  }

  setSkillsSuggestions(suggestions: SuggestedTitle[]) {
    const suggestionsWithKey = suggestions.map(suggestion => {
      return {
        key: `${suggestion.name}.aisearch`,
        chipkey: suggestion.name,
        isExcluded: false,
        isMandatory: false,
        isSuggestion: true,
        suggestedTitle: { name: suggestion.name, selected: true, type: 'skill', key: this.getSafeKey(suggestion.name) }
      };
    });
    const existingSuggestions = this.skillsSelectedList.filter(suggestion => suggestion.isSuggestion);
    const newSuggestions = suggestionsWithKey.filter(suggestion => !existingSuggestions.find(existingSuggestion => existingSuggestion.chipkey === suggestion.chipkey));
    this.skillsSelectedList.push(...newSuggestions);
    if (newSuggestions.length) {
      this.setFilterDataInLocalStorage();
      this.getPersonSearchRecommendedCandidates();
    }
  }

  openaiPastJobTitleLoading({ state, count, suggested }) {
    this.isOpenAIPastJobTitleLoading = state;
    this.showOpenAIPastJobTitleSuggestions = count;

    suggested && (this.aiSuggestedPastJobTitles = suggested);
    this.openAIAll && !state && (suggested !== undefined && suggested !== null) && suggested.length < 5 && this.getFilterWiseDataToDisplay('pastjobtitle', true);
  }

  setPastJobTitleSuggestions(suggestions: SuggestedTitle[]) {
    const suggestionsWithKey = suggestions.map(suggestion => {
      return {
        key: `${suggestion.name}.aisearch`,
        chipkey: suggestion.name,
        isExcluded: false,
        isMandatory: false,
        isSuggestion: true,
        suggestedTitle: { name: suggestion.name, selected: true, type: 'title', key: this.getSafeKey(suggestion.name) }
      };
    });
    const existingSuggestions = this.pastJobTitleSelectedList.filter(suggestion => suggestion.isSuggestion);
    const newSuggestions = suggestionsWithKey.filter(suggestion => !existingSuggestions.find(existingSuggestion => existingSuggestion.chipkey === suggestion.chipkey));
    this.pastJobTitleSelectedList.push(...newSuggestions);
    if (newSuggestions.length) {
      this.setFilterDataInLocalStorage();
      this.getPersonSearchRecommendedCandidates();
    }
  }

  removeTypeahead(type: any) {
    const maxLength = 3
    switch (type) {
      case 'jobtitle': {
        if (!(this.jobTitleInput && this.jobTitleInput.value && this.jobTitleInput.value.length >= maxLength)) {
          this.jobTitleList = []
        }
        break;
      }
      case 'skills': {
        if (!(this.skillsInput && this.skillsInput.value)) {
          this.skillsList = []
        }
        break;
      }
      case 'company': {
        if (!(this.companyInput && this.companyInput.value)) {
          this.companyList = []
        }
        break;
      }
      case 'industry': {
        if (!(this.industryInput && this.industryInput.value && this.industryInput.value.length >= maxLength)) {
          this.industryList = []
        }
        break;
      }
      case 'fieldofstudy': {
        if (!(this.fieldOfStudyInput && this.fieldOfStudyInput.value && this.fieldOfStudyInput.value.length >= maxLength)) {
          this.fieldOfStudyList = []
        }
        break;
      }
      case 'education': {
        if (!(this.educationInput && this.educationInput.value && this.educationInput.value.length >= maxLength)) {
          this.educationList = []
        }
        break;
      }
      case 'school': {
        if (!(this.schoolInput && this.schoolInput.value && this.schoolInput.value.length >= maxLength)) {
          this.schoolList = []
        }
        break;
      }
      case 'location': {
        if (!(this.locationInput && this.locationInput.value && this.locationInput.value.length >= maxLength)) {
          this.locationList = []
        }
        break;
      }
      case 'pastjobtitle': {
        if (!(this.pastJobTitleInput && this.pastJobTitleInput.value && this.pastJobTitleInput.value.length >= maxLength)) {
          this.pastJobTitleList = []
        }
        break;
      }
      case 'functions': {
        if (!(this.functionsInput && this.functionsInput.value && this.functionsInput.value.length >= maxLength)) {
          this.functionsList = []
        }
        break;
      }
      case 'fullname': {
        if (!(this.nameInput && this.nameInput.value && this.nameInput.value.length >= maxLength)) {
          this.fullnameList = []
        }
        break;
      }
      case 'schoollocation': {
        if (!(this.schoolLocationInput && this.schoolLocationInput.value && this.schoolLocationInput.value.length >= maxLength)) {
          this.schoolLocationList = []
        }
        break;
      }
    }
  }

  private getSafeKey(str: string): string {
    return str.toLowerCase().replace(/[^a-zA-Z0-9]/g, '');
  }

  capitalizeFirstLetter(continent: any = []) {
    if (continent && continent !== null && continent !== undefined && continent.length >= 1 && Array.isArray(continent)) {
      const continentValue = _.flatten(continent)[0];
      return continentValue.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
    }
  }

  getFilterWiseDataToDisplay(filterName, callApi = false) {
    if (filterName === "jobtitle") {
      if (this.showOpenAITitleSuggestions && !callApi) return;
      this.jobtitletype === CallStage.CURRENT_OR_PAST.toString() && this.getAggregationsForFilter("jobtitle", "jobtitle", callApi);
      this.jobtitletype === CallStage.CURRENT.toString() && this.getAggregationsForFilter("jobtitle", "current_jobtitle", callApi);
      this.jobtitletype === CallStage.PAST.toString() && this.getAggregationsForFilter("jobtitle", "pastjobtitle", callApi);
    } else if (filterName == 'pastjobtitle') {
      this.getAggregationsForFilter("pastjobtitle", "pastjobtitle", callApi);
    }
    else if (filterName === "skills") {
      if (this.showOpenAISkillsSuggestions && !callApi) return;
      this.getAggregationsForFilter('skills', 'skills', callApi);
    } else if (filterName === "pastjobtitle") {
      if (this.showOpenAIPastJobTitleSuggestions && !callApi) return;
      this.getAggregationsForFilter("pastjobtitle", "pastjobtitle", callApi);
    }
  }

  getAggregationsForFilter(filterName: string, aggregateType: string, updateSelectedList = false) {
    const payload = this.requestObject;
    payload['aggregatetype'] = aggregateType;
    delete payload['typeahead']

    this.personSearchService.getTotalAggs(payload).subscribe(response => {
      if (response.status == 'success') {
        const reportsAggs = response.data.aggregations;
        switch (filterName) {
          case 'jobtitle': {
            this.jobTitleTopList = (this.jobtitletype == CallStage.CURRENT.toString() ? reportsAggs['current_jobtitle'] : this.jobtitletype == CallStage.PAST.toString() ? reportsAggs['pastjobtitle'] : reportsAggs?.jobtitle) || [];
            this.jobTitleTopList = this.jobTitleTopList.filter(jobTitle => !this.jobTitleSelectedList.some(selectedJobTitle => selectedJobTitle.chipkey.toLowerCase() == jobTitle.key.toLowerCase()))
            if (updateSelectedList) {
              const titlesToBeUpdated = [];
              let noOfSuggestionsToAdd = 5 - (this.aiSuggestedTitles ? this.aiSuggestedTitles.length : 0);
              noOfSuggestionsToAdd && this.jobTitleTopList.forEach((jobTitle) => {
                if (noOfSuggestionsToAdd) {
                  const isTitlePresent = this.aiSuggestedTitles.find(j => j.name.toLowerCase() == jobTitle.key.toLowerCase());
                  if (!isTitlePresent) {
                    titlesToBeUpdated.push({ name: jobTitle.key, selected: false, type: 'title', key: this.getSafeKey(jobTitle.key) });
                    noOfSuggestionsToAdd--;
                  }
                }
              });
              this.showOpenAITitleSuggestions += titlesToBeUpdated.length;
              this.updatedAiTitleChips.emit(titlesToBeUpdated);
            }
          }
          case 'skills': {
            this.skillsTopList = reportsAggs?.skills ? reportsAggs?.skills : [];
            this.skillsTopList = this.skillsTopList.filter(skill => !this.skillsSelectedList.some(selectedSkill => selectedSkill.chipkey.toLowerCase() == skill.key.toLowerCase()))
            if (updateSelectedList) {
              const skillsToBeUpdated = [];
              let noOfSuggestionsToAdd = 5 - (this.aiSuggestedSkills ? this.aiSuggestedSkills.length : 0);
              noOfSuggestionsToAdd && this.skillsTopList.forEach((skill) => {
                if (noOfSuggestionsToAdd) {
                  const isSkillPresent = this.aiSuggestedSkills.find(s => s.name.toLowerCase() == skill.key.toLowerCase());
                  if (!isSkillPresent) {
                    skillsToBeUpdated.push({ name: skill.key, selected: false, type: 'skill', key: this.getSafeKey(skill.key) });
                    noOfSuggestionsToAdd--;
                  }
                }
              });
              this.showOpenAISkillsSuggestions += skillsToBeUpdated.length;
              this.updatedAiSkillChips.emit(skillsToBeUpdated);
            }
          }
          case 'pastjobtitle': {
            this.pastJobTitleTopList = reportsAggs?.pastjobtitle ? reportsAggs?.pastjobtitle : [];
            this.pastJobTitleTopList = this.pastJobTitleTopList.filter(jobTitle => !this.pastJobTitleSelectedList.some(selectedJobTitle => selectedJobTitle.chipkey.toLowerCase() == jobTitle.key.toLowerCase()))
            if (updateSelectedList) {
              const titlesToBeUpdated = [];
              let noOfSuggestionsToAdd = 5 - (this.aiSuggestedPastJobTitles ? this.aiSuggestedPastJobTitles.length : 0);
              noOfSuggestionsToAdd && this.pastJobTitleTopList.forEach((jobTitle) => {
                if (noOfSuggestionsToAdd) {
                  const isTitlePresent = this.aiSuggestedPastJobTitles.find(j => j.name.toLowerCase() == jobTitle.key.toLowerCase());
                  if (!isTitlePresent) {
                    titlesToBeUpdated.push({ name: jobTitle.key, selected: false, type: 'title', key: this.getSafeKey(jobTitle.key) });
                    noOfSuggestionsToAdd--;
                  }
                }
              });
              this.showOpenAIPastJobTitleSuggestions += titlesToBeUpdated.length;
              this.updatedAiPastJobTitleChips.emit(titlesToBeUpdated);
            }
          }
        }
      }
    });
  }

  getCompanyAiSuggestions() {
    this.companyAiSuggestions = [];
    this.loadSuggestions = false;
    const payload = {
      startindex: 0,
      resultsize: 10,
      searchviaboolean: true,
      booleanquery: "*",
      industries: [],
      locations: [],
      companysizes: [],
      companynames: this.companySelectedList.filter(c => !c.isSuggesteds).map(company => company.key.replace('.aisearch', '')),
    }
    this.companyInsightsService.getRecommendedcompanies(payload).subscribe((res: any) => {
      if (res && res.status === 'success') {
        this.industryForCompanyAiSuggestions = res?.data?.results ? res?.data?.results.filter(company => this.companySelectedList.find(c => c.chipkey.toLowerCase() == company.name)).map(company => company.industry) : [];
        const localRequestObject = Object.assign({}, this.requestObject);

        localRequestObject['industries'] = _.uniq(this.industryForCompanyAiSuggestions);

        delete localRequestObject.searchedfrom;

        const aggregatetype = this.companytype == 'Current' ? 'current_company' : this.companytype == 'Past' ? 'pastcompany' : 'company';

        Object.assign(localRequestObject, {
          resultsize: 1,
          aggregatetype: aggregatetype,
          typeahead: "typeahead_currentcompany",
          input: "",
        });

        this.personSearchService.getTotalAggs(localRequestObject).subscribe((response) => {
          if (response && response.status === 'success') {
            const reportsAggs = response.data.aggregations;
            this.companyAiSuggestions = this.companytype == 'Current' ? reportsAggs?.current_company : this.companytype == 'Past' ? reportsAggs?.pastcompany : reportsAggs?.company || [];
            this.loadSuggestions = true;
            this.companyAiSuggestions = this.companyAiSuggestions?.filter(c => !this.companySelectedList.find(company => company.chipkey.toLowerCase() == c.key)).slice(0, 5).map(c => ({
              ...c, key: `${c.key}.aisearch`,
              chipkey: c.key,
              isExcluded: false,
              isMandatory: false,
              isSuggestion: true,
              isSuggested: true
            }))
          }
        });
      }
    });
  }

  removeAllAiSuggestion() {
    this.clearAiTitleChips.emit();
    this.clearAiSkillChips.emit();
    this.clearAiPastTitleChips.emit();
  }



  /**
   * set Filter data
   * @param replace
   */
  setFilterDataInLocalStorage(replace: boolean = false) {

    const filterData = {
      jobTitleStatus: this.jobtitletype,
      industryStatus: this.industrytype,
      companyStatus: this.companytype,
      jobTitleSelectedList: this.jobTitleSelectedList,
      pastJobTitleSelectedList: this.pastJobTitleSelectedList,
      skillsSelectedList: this.skillsSelectedList,
      industrySelectedList: this.industrySelectedList,
      locationSelectedList: this.locationSelectedList,
      distancefromselectedlocations: Number(this.distanceform.value),
      distancefromselectedlocationsmeasurementunit: this.distancetype.value,
      companySelectedList: this.companySelectedList,
      companysize: this.companysize,
      functionSelectedList: this.functionSelectedList,
      seniority: this.seniority,
      educationSelectedList: this.educationSelectedList,
      fieldOfStudySelectedList: this.fieldOfStudySelectedList,
      schoolSelectedList: this.schoolSelectedList,
      schoolLocationSelectedList: this.schoolLocationSelectedList,
      fullNameSelectedList: this.fullNameSelectedList,
      gender: this.gender,
      totalYearsOfExperienceType: this.experiencetype,
      yearsofexperienceFrom: this.fromyearsofexperience ? this.fromyearsofexperience : null,
      yearsofexperienceTo: this.toyearsofexperience ? this.toyearsofexperience : null,
      currentfromyearsofexperience: this.currentfromyearsofexperience ? this.currentfromyearsofexperience : null,
      currenttoyearsofexperience: this.currenttoyearsofexperience ? this.currenttoyearsofexperience : null,
      fetchtotalpersoncountincontinent: true,
      continentstobeincluded: this.localstorageservice.getItem('region'),
      tograduationyear: this.tograduationyearFilter,
      fromgraduationyear: this.fromgraduationyearFilter,
      booleanquery: this.booleanSearchString ? this.booleanSearchString : '*'

    }

    const localKey = GlobalService.hash(JSON.stringify(cjson.compress(filterData)));
    if (!window.location.search.includes(localKey)) {
      localStorage.setItem(localKey, JSON.stringify(cjson.compress(filterData)));
      const parsedUrl = this.router.parseUrl(this.router.url);
      this.locationService[replace ? 'replaceState' : 'go'](parsedUrl.toString().split('?')[0], 'filter=' + encodeURIComponent(localKey));
    }
  }


  /**
   * Update all selected filter from localstorage
   * @param filter - Filter key to get filterdata from localstorage
   */
  loadFilterFromLocalStorage(filterData: any) {

    if (this.recomandSubscription) {
      this.recomandSubscription.unsubscribe();
    };

    if (filterData && filterData.jobTitleStatus) {
      this.jobtitletype = filterData.jobTitleStatus;
    } else {
      this.jobtitletype = CallStage.CURRENT.toString();
    }

    if (filterData && filterData.companyStatus) {
      this.companytype = filterData.companyStatus;
    } else {
      this.companytype = CallStage.CURRENT.toString();;
    }

    if (filterData && filterData.industryStatus) {
      this.industrytype = filterData.industryStatus;
    } else {
      this.industrytype = CallStage.CURRENT.toString();;
    }

    if (filterData && filterData.jobTitleSelectedList) {
      this.jobTitleSelectedList = _.clone(filterData.jobTitleSelectedList, true);
    } else {
      this.jobTitleSelectedList = [];
    }

    if (filterData && filterData.pastJobTitleSelectedList) {
      this.pastJobTitleSelectedList = _.clone(filterData.pastJobTitleSelectedList, true);
    } else {
      this.pastJobTitleSelectedList = [];
    }

    if (filterData && filterData.locationSelectedList) {
      this.locationSelectedList = _.clone(filterData.locationSelectedList, true);
      const locationType = _.pluck(this.locationSelectedList, 'location_type');
      this.locationType = locationType.length > 0 && locationType.indexOf('city') !== -1 ? 'city' : null;
    } else {
      this.locationSelectedList = [];
      this.locationType = null;
    }

    if (filterData && filterData.skillsSelectedList) {
      this.skillsSelectedList = _.clone(filterData.skillsSelectedList, true);
    } else {
      this.skillsSelectedList = [];
    }

    if (filterData && filterData.companySelectedList) {
      this.companySelectedList = _.clone(filterData.companySelectedList, true);
    } else {
      this.companySelectedList = [];
    }

    if (filterData && filterData.companysize) {
      if (filterData.companysize.includes("All")) {
        this.companysize = ["All", "1-10", "11-50", "51-200", "201-500", "501-1000", "1001-5000", "5001-10000", "10001+"]
      } else {
        this.companysize = _.clone(filterData.companysize, true);
      }
    } else {
      this.companysize = ["All", "1-10", "11-50", "51-200", "201-500", "501-1000", "1001-5000", "5001-10000", "10001+"]
    }

    if (filterData && filterData.industrySelectedList) {
      this.industrySelectedList = _.clone(filterData.industrySelectedList, true);
    } else {
      this.industrySelectedList = [];
    }

    if (filterData && filterData.functionSelectedList) {
      this.functionSelectedList = _.clone(filterData.functionSelectedList, true);
    } else {
      this.functionSelectedList = [];
    }

    if (filterData && filterData.seniority) {
      if (filterData.seniority.includes("All")) {
        this.seniority = ["All", "cxo", "director", "entry", "manager", "owner", "partner", "senior", "training", "unpaid", "vp"]
      } else {
        this.seniority = _.clone(filterData.seniority, true);
      }
    } else {
      this.seniority = ["All", "cxo", "director", "entry", "manager", "owner", "partner", "senior", "training", "unpaid", "vp"]
    }

    if (filterData && filterData.educationSelectedList) {
      this.educationSelectedList = _.clone(filterData.educationSelectedList, true);
    } else {
      this.educationSelectedList = [];
    }

    if (filterData && filterData.schoolLocationSelectedList) {
      this.schoolLocationSelectedList = _.clone(filterData.schoolLocationSelectedList, true);
    } else {
      this.schoolLocationSelectedList = [];
    }

    if (filterData && filterData.schoolSelectedList) {
      this.schoolSelectedList = _.clone(filterData.schoolSelectedList, true);
    } else {
      this.schoolSelectedList = [];
    }

    if (filterData && filterData.fieldOfStudySelectedList) {
      this.fieldOfStudySelectedList = _.clone(filterData.fieldOfStudySelectedList, true);
    } else {
      this.fieldOfStudySelectedList = [];
    }

    if (filterData && filterData.fullNameSelectedList) {
      this.fullNameSelectedList = _.clone(filterData.fullNameSelectedList, true);
    } else {
      this.fullNameSelectedList = [];
    }

    if (filterData && filterData.gender) {
      this.gender = filterData.gender;
    } else {
      this.gender = 'All';
    }

    if (filterData && filterData.totalYearsOfExperienceType) {
      this.experiencetype = filterData.totalYearsOfExperienceType;
    }

    if (filterData && filterData.yearsofexperienceFrom) {
      this.yearsofexperienceFrom.setValue(filterData.yearsofexperienceFrom);
      this.fromyearsofexperience = filterData.yearsofexperienceFrom;
    } else {
      this.yearsofexperienceFrom.setValue(null);
      this.fromyearsofexperience = null;
    }

    if (filterData && filterData.yearsofexperienceTo) {
      this.yearsofexperienceTo.setValue(filterData.yearsofexperienceTo);
      this.toyearsofexperience = filterData.yearsofexperienceTo;
    } else {
      this.yearsofexperienceTo.setValue(null);
      this.toyearsofexperience = null;
    }

    if (filterData && filterData.currentfromyearsofexperience) {
      this.currentyearsofexperienceFrom.setValue(filterData.currentfromyearsofexperience);
      this.currentfromyearsofexperience = filterData.currentfromyearsofexperience;
    } else {
      this.currentyearsofexperienceFrom.setValue(null);
      this.currentfromyearsofexperience = null;
    }

    if (filterData && filterData.currenttoyearsofexperience) {
      this.currentyearsofexperienceTo.setValue(filterData.currenttoyearsofexperience);
      this.currenttoyearsofexperience = filterData.currenttoyearsofexperience;
    } else {
      this.currentyearsofexperienceTo.setValue(null);
      this.currenttoyearsofexperience = null;
    }

    if (filterData && filterData.distancefromselectedlocations) {
      this.distanceform.patchValue(filterData.distancefromselectedlocations);
    } else {
      this.distanceform.patchValue(20);
    }

    if (filterData && filterData.distancefromselectedlocationsmeasurementunit) {
      this.distancetype.patchValue(filterData.distancefromselectedlocationsmeasurementunit);
    } else {
      this.distancetype.patchValue('kilometers');
    }

    if (filterData && filterData.continentstobeincluded) {
      this.continent = [filterData.continentstobeincluded];
      this.continentHandlerService.emitContinentUpdate(filterData.continentstobeincluded);
      this.localstorageservice.setItem('region', filterData.continentstobeincluded)
    }
    if (filterData?.tograduationyear || filterData?.fromgraduationyear) {
      this.tograduationyearFilter = filterData.tograduationyear;
      this.fromgraduationyearFilter = filterData.fromgraduationyear;
    }
    this.getPersonSearchRecommendedCandidates();

  };

  dismiss() {
    this.modalService.dismissAll();
  }




  isLocationDisabled(location: any): boolean {
    return this.hasEuAccess != 1 && location.location_continent.toLowerCase() === 'europe';

  }

  getTooltipText(location: any): string {
    if (this.isLocationDisabled(location)) {
      return 'This location cannot be selected due to GDPR regulations. \n As part of our commitment to EU data protection regulations, candidate personal data (PII) is not displayed or processed for EU-based profiles.';
    } else {
      return `${this.capitalizeFirst(location?.value)} | ${this.capitalizeFirst(location?.location_type)}`;
    }
  }

  capitalizeFirst(value: string): string {
    if (!value) return '';

    return value
      .toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }


  get geoIpLocation() {
    const location = JSON.parse(this.localstorageservice.getItem('userGeoIpLocation'));
    const country = location?.country?.toLowerCase();
    const city = location?.city?.toLowerCase();
    const region = location?.region?.toLowerCase();
    const continent = location?.continent?.toLowerCase();
    return { location: `${city || ''}${city && (region || country) ? ', ' : ''}${region || ''}${region && country ? ', ' : ''}${country || ''}`, continent }
  }

  /**
 * Used to form array of objects for highlights filters on the basis of data got from backend.
 */
  highlightOptionsCall() {
    this.personSearchService.getHighlightsOptions().subscribe((res: any) => {
      if (res?.data && Array.isArray(res.data)) {
        this.highLightOptions = this.highlightOptionsObjectFormation(res.data);
      }
    })
  }

  /**
 * Used to form array of Object for highlights filter on the basis of backend data and Map them with label, color and id;
 * @param data array of values of filters
 */
  highlightOptionsObjectFormation(data: string[]) {
    const highlight = [];
    data && data.length && data.map(x => {
      if (x === 'Unicorns') {
        highlight.push(
          { id: 1, label: 'Unicorn Experience', value: `${x}`, color: 'yellow', imageName: 'unicorn' }
        )
      } else if (x === 'Techie') {
        highlight.push(
          { id: 2, label: 'Techie', value: `${x}`, color: 'green', imageName: 'techie' }
        )
      } else if (x === 'Fortune-500') {
        highlight.push(
          { id: 3, label: 'Fortune 500 Experience', value: `${x}`, color: 'fortune', imageName: 'fortune500' }
        )
      } else if (x === 'Tier-1 School') {
        highlight.push(
          { id: 4, label: 'Tier 1 School', value: `${x}`, color: 'teal', imageName: 'tier1school' }
        )
      } else if (x === 'C9 League (China)') {
        highlight.push(
          { id: 5, label: 'C9 League (China)', value: `${x}`, color: 'c9League', imageName: 'c9' }
        )
      } else if (x === 'Ivy League (USA)') {
        highlight.push(
          { id: 6, label: 'Ivy League (USA)', value: `${x}`, color: 'ivy', imageName: 'ivy' }
        )
      } else if (x === 'Group of Eight (Australia)') {
        highlight.push(
          { id: 7, label: 'Group of Eight (Australia)', value: `${x}`, color: 'groupOfEight', imageName: 'go8' }
        )
      } else if (x === 'Russell Group (UK)') {
        highlight.push(
          { id: 8, label: 'Russell Group (UK)', value: `${x}`, color: 'russellGroup', imageName: 'russell' }
        )
      } else if (x === 'MAANG') {
        highlight.push(
          { id: 9, label: 'MAANG', value: `${x}`, color: 'maang', imageName: 'maang' }
        )
      } else if (x === 'DAX 40') {
        highlight.push(
          { id: 10, label: 'DAX 40', value: `${x}`, color: 'dax', imageName: 'dax40' }
        )
      } else if (x === 'NASDAQ 100') {
        highlight.push(
          { id: 11, label: 'NASDAQ 100', value: `${x}`, color: 'nasdaq', imageName: 'nasdaq100' }
        )
      } else if (x === 'Nifty 50 / Sensex') {
        highlight.push(
          { id: 12, label: 'Nifty 50 / Sensex', value: `${x}`, color: 'nifty', imageName: 'nifty50' }
        )
      } else if (x === 'Fortune Global 500') {
        highlight.push(
          { id: 13, label: 'Fortune Global 500', value: `${x}`, color: 'fortuneGlobal', imageName: 'fortuneglobal500' }
        )
      } else if (x === 'S&P 500') {
        highlight.push(
          { id: 14, label: 'S&P 500', value: `${x}`, color: 'sp', imageName: 'sp500' }
        )
      } else if (x === 'Big Four') {
        highlight.push(
          { id: 15, label: 'Big 4', value: `${x}`, color: 'bigfour', imageName: 'big4' }
        )
      } else if (x === 'DOW 30') {
        highlight.push(
          { id: 16, label: 'DOW 30', value: `${x}`, color: 'dow', imageName: 'dow30' }
        )
      } else if (x === 'Fortune 500') {
        highlight.push(
          { id: 17, label: 'Fortune 500', value: `${x}`, color: 'fortune', imageName: 'fortune500' }
        )
      } else if (x === 'Big Oil') {
        highlight.push(
          { id: 18, label: 'Big Oil', value: `${x}`, color: 'bigoil', imageName: 'bigoil' }
        )
      } else if (x === 'FTSE 100') {
        highlight.push(
          { id: 19, label: 'FTSE 100', value: `${x}`, color: 'ftse', imageName: 'ftse100' }
        )
      } else if (x === 'U15 Group (Canada)') {
        highlight.push(
          { id: 20, label: 'U15 Group (Canada)', value: `${x}`, color: 'u15group', imageName: 'u15' }
        )
      } else if (x === 'BATX') {
        highlight.push(
          { id: 21, label: 'BATX', value: `${x}`, color: 'batx', imageName: 'batx' }
        )
      }
    })
    return highlight;
  }

  /**
   * On change on highlights checkbox
   * @param event event of highlight checkbox
   */
  onChangeHighlights(event) {
    this.highlightsSelectedList = this.highLightOptions.filter(x => event.value.includes(x.id))
    this.highlightSelectedControl = _.pluck(this.highlightsSelectedList, 'id');
    this.selectedItem('highlights', null);
    this.getPersonSearchRecommendedCandidates();
  }

  clearBoolean() {
    this.booleanSearchString = '';
    this.keywordInput.setValue('');
    this.getPersonSearchRecommendedCandidates();
  }

  closeAdvanceSearch() {
    this.modalService.dismissAll();
  }

  checkIfFilterisSelected() {
    if(this.jobTitleSelectedList?.length || this.pastJobTitleSelectedList?.length || this.skillsSelectedList?.length || this.industrySelectedList?.length || this.companySelectedList?.length ||
      this.companysize?.length || this.functionSelectedList?.length || this.seniority?.length || this.fromyearsofexperience || this.toyearsofexperience ||
      this.currentfromyearsofexperience || this.currenttoyearsofexperience || this.educationList?.length || this.fieldOfStudySelectedList?.length ||
      this.schoolLocationSelectedList?.length || this.schoolSelectedList?.length || this.fromgraduationyearFilter || this.tograduationyearFilter || this.fullnameList?.length  ||
      this.highlightsSelectedList?.length || this.positionhierarchy?.length || this.keywordInput?.value || this.distanceform?.valid || this.distancetype?.valid) {
        return true;
      }
      return false;
  }
}

